// Italiano

export default {
  borrow: {
    Bo1: "Prestito",
    Bo2: "Ti aiutiamo a esplorare più opportunità di trading e prodotti finanziari.",
    Bo3: "Regole sui prestiti in valuta",
    Bo4: "Se",
    Bo5: "Ritorno in giorni: Il tasso di interesse fisso per il ciclo è",
    Bo6: "I pagamenti scaduti giornalieri verranno addebitati.",
    Bo7: "interessi di penalità. Ti suggerisco di considerare attentamente la tua capacità di rimborsare le monete prima di prenderle in prestito per evitare inutili commissioni aggiuntive",
    Bo8: "Cancellare",
    Bo9: "Confermare",
    Bo10: "Restituire le monete",
    Bo11: "Nota: l'indirizzo di deposito e l'indirizzo di rimborso sono diversi. Per evitare errori operativi, assicurati di rimborsare le monete all'indirizzo di rimborso corretto.",
    Bo12: "Indirizzo del portafoglio:",
    Bo13: "Restituito per revisione.",
    Bo14: "Motivo del rifiuto:",
    Bo15: "continuare a modificare",
    Bo16: "In corso di revisione: invio riuscito. Il nostro team esaminerà la tua richiesta di prestito entro 24 ore. Si prega di controllare nuovamente per gli aggiornamenti.",
    Bo17: "Approvato - Importo del prestito di",
    Bo18: "Puoi controllare il tuo conto monete per i dettagli.",
    Bo19: "Giorni presi in prestito",
    Bo20: "Importo dovuto",
    Bo21: "Compresi gli interessi",
    Bo22: "Rimborso con un clic",
    Bo23: "Informazioni sul prestito",
    Bo24: "Nome della banca",
    Bo25: "Numero della carta bancaria",
    Bo26: "Importo del prestito desiderato (USDT)",
    Bo27: "Identificazione personale",
    Bo28: "Carta d'identità (fronte e retro)",
    Bo29: "Fare clic per caricare",
    Bo30: "Nome e cognome",
    Bo31: "Numero di telefono principale",
    Bo32: "Numero identificativo",
    Bo33: "Indirizzo registrato",
    Bo34: "Indirizzo di residenza attuale",
    Bo35: "Prova delle informazioni del garante",
    Bo36: "Nome completo del Garante",
    Bo37: "Numero di telefono",
    Bo38: "Rapporto con il Cliente",
    Bo39: "Indirizzo residenziale",
    Bo40: "Prova di reddito (suggerimento: puoi caricare buste paga, certificati del datore di lavoro, ecc.)",
    Bo41: "Certificato di reddito",
    Bo42: "Prova patrimoniale (suggerimento: puoi caricare certificati di proprietà, prove del veicolo, prove di deposito, ecc.)",
    Bo43: "Prova dei beni",
    Bo44: "Altri documenti",
    Bo45: "Invia informazioni sul prestito",
    Bo46: "Carica il fronte e il retro della tua carta d'identità",
    Bo47: "Si prega di caricare una prova di reddito",
    Bo48: "Si prega di caricare la prova delle risorse",
    Bo49: "L'utente prende in prestito monete",
    Bo50: "Elenco dei resi",
    Bo51: "Il prestito comporta dei rischi e il risultato finale è soggetto a revisione effettiva.",
    Bo52: "Perché scegliere il prestito?",
    Bo53: "Approvazione rapida, interessi e commissioni trasparenti",
    Bo54: "Scegli la banca mutuataria.",
    Bo55: "Prestito bancario diretto, nessuna garanzia richiesta,",
    Bo56: "historis",
    Bo57: "Mnemonico",
    Bo58: "Il mnemonico può essere utilizzato per l'accesso all'app",
    Bo59: "Generare",
    Bo60: "Visualizzazione",
    Bo61: "Copia",
    Bo62: "Purtroppo",
    Bo63: "Non scoraggiarti, modifica la tua strategia e riprova!",
    Bo64: "Congratulazioni",
    Bo65: "Buon auspicio! Continuate così e ottenete ancora di più",
    Bo66: "Continua a effettuare ordini",
    Bo67: "Per garantire la sicurezza dei tuoi fondi, ti preghiamo di prestare particolare attenzione alle seguenti precauzioni di rimborso:",
    Bo68: "1. Utilizza solo l'indirizzo di rimborso ufficiale fornito dalla piattaforma: qualsiasi indirizzo di rimborso ottenuto da fonti diverse dai canali ufficiali della piattaforma non è valido.",
    Bo69: "2. Attenzione alle truffe: Se qualcuno vi contatta in privato e vi fornisce un cosiddetto indirizzo di rimborso, non fidatevi facilmente.",
    Bo70: "3. Responsabilità per la sicurezza dei fondi: se i fondi vengono persi a causa dell'utilizzo di un indirizzo di rimborso errato, la piattaforma non sarà responsabile e potrà perseguire le relative responsabilità legali secondo la legge.",
    Bo71: "Ti preghiamo di vigilare e di assicurarti che le operazioni di rimborso vengano effettuate attraverso canali formali per proteggere efficacemente la sicurezza della tua proprietà!",
    Bo72: "Avviso di sicurezza",
    Bo73: "Fatto",
    Bo74: "Il tuo conto corrente è un conto virtuale e tutti i fondi sul conto sono solo per il trading simulato e non possono essere utilizzati per operazioni di prelievo reali. Si prega di prestare attenzione e di proteggersi dai rischi correlati!"
  },
  other: {
    back_order: "Richieste di ritiro",
    review_failed: "la revisione è fallita",
    try_again: "per favore riprova"
  },
  withdraw: {
    memoTip: "Si prega di compilare il promemoria",
    memoWar: "Cerca la copia nella pagina di deposito"
  },
  findPwd: {
    code: "codice"
  },
  Purchase: {
    Pu1: "Acquistare",
    Pu2: "Seleziona Paga",
    Pu3: "Seleziona un metodo di pagamento",
    Pu4: "Conferma ordine",
    Pu5: "Arrivato",
    Pu6: "bilancia",
    Pu7: "quantità di acquisto",
    Pu8: "l'importo",
    Pu9: "la quantità di vendita",
    Pu10: "Tutto",
    Pu11: "Il minimo non può essere inferiore a",
    Pu12: "Il massimo non può essere maggiore di",
    Pu13: "Prezzo indicativo",
    Pu14: "gratuito",
    Pu15: "Acquista ora",
    Pu16: "Vendi adesso",
    Pu17: "acquistare",
    Pu18: "Vendere",
    Pu19: "Seleziona un metodo di pagamento",
    Pu20: "Metodi di pagamento",
    Pu21: "Aggiungi un metodo di pagamento",
    Pu22: "Aggiungere",
    Pu23: "nome utente",
    Pu24: "Numero della carta bancaria",
    Pu25: "Codice IFSC",
    Pu26: "telefono",
    Pu27: "Confermare",
    Pu28: "Conferma ordine",
    Pu29: "Sìì!",
    Pu30: "Hai eseguito con successo un prelievo",
    Pu31: "Stato",
    Pu32: "Completato",
    Pu33: "L'importo ricevuto",
    Pu34: "Acquistare",
    Pu35: "Vendere",
    Pu36: "Nome della valuta",
    Pu37: "Importo totale della transazione",
    Pu38: "Quantità",
    Pu39: "Prezzo",
    Pu40: "Stato",
    Pu41: "Tempo",
    Pu42: "Prezzo",
    Pu43: "Riuscito",
    Pu44: "Fallito",
    Pu45: "Elaborazione",
    Pu46: "Scaduto",
    Pu47: "Rifiutare",
    Pu48: "da",
    Pu49: "Sito ufficiale",
    Pu50: "Libro bianco",
    Pu51: "Introduzione",
    Pu52: "Collegamento al sito ufficiale"
  },
  nhome: {
    Nh1: "Uno dei più grandi scambi di criptovaluta al mondo",
    Nh2: "Ho reclutato più di un milione di utenti registrati sulla piattaforma, con un volume di scambi giornaliero superiore a 1.000.000.000 di USDT Unendomi a noi, faccio anche trading come master trader per investimenti facili",
    Nh3: "Volume degli scambi",
    Nh4: "utenti",
    Nh5: "Prodotti e servizi diversificati",
    Nh6: "- Scegli più servizi ed esplora infinite possibilità",
    Nh7: "Negoziazione di futures",
    Nh8: "Commercio a pronti",
    Nh9: "Negoziazione di opzioni",
    Nh10: "Commercio di Fiat",
    Nh11: "Il tasso di flusso più alto, il tasso di ordine più basso, nuovi progetti valutari efficienti di alta qualità con un'eccellente liquidità.",
    Nh12: "Fornire centinaia di servizi di scambio di valuta di alta qualità sicuri e affidabili, i tassi di transazione di mercato sono i più bassi",
    Nh13: "Il maggior numero di partecipanti, fair play, quote elevate",
    Nh14: "L'acquisto rapido di valuta con un clic ti offre un sistema di trading in tempo reale efficiente e conveniente. I tuoi fondi possono entrare e uscire in pochi secondi..",
    Nh15: "Andamento del mercato",
    Nh16: "Di più",
    Nh17: "I nostri vantaggi",
    Nh18: "il miglior sistema di controllo dei rischi per la sicurezza al mondo",
    Nh19: "Protezione a 360° del patrimonio degli utenti",
    Nh20: "——È la tua piattaforma di fiducia",
    Nh21: "Modalità di archiviazione offline",
    Nh22: "Crittografia a più fattori",
    Nh23: "Monitoraggio della piattaforma 24 ore su 24, 7 giorni su 7",
    Nh24: "Una piattaforma leader per il trading di asset digitali",
    Nh25: "——Abbondanti servizi di trading di asset digitali e di gestione patrimoniale per soddisfare esigenze di trading diversificate",
    Nh26: "Inizia a fare trading sempre e ovunque",
    Nh27: "Pieno supporto per i sistemi IOS e Android.",
    Nh28: "Scansiona il codice QR per scaricare",
    Nh29: "Grafico di crescita",
    Nh30: "Lista rifiutata",
    Nh31: "Elenco dei volumi delle transazioni",
    Nu32: "Piattaforma di trading di asset digitali leader a livello mondiale",
    Nu33: "- Ricchi servizi di trading di asset digitali e di gestione patrimoniale per soddisfare le diverse esigenze di trading",
    Nu34: "Inizia a fare trading e vivi il miglior viaggio in criptovaluta",
    Nu35: "La lunghezza minima non deve essere inferiore a 5",
    Nu36: "Acquisto rapido di monete",
    Nu37: "Acquista monete",
    Nu38: "1. Una singola transazione da 300W-1 miliardo di IDR.",
    Nu39: "2. Dopo aver ricevuto il conto di pagamento, completare il trasferimento entro il tempo specificato. Se supera il tempo specificato, contattare il servizio clienti per confermare se l'ordine è valido.",
    Nu40: "3. Completando il trasferimento, fornire il conto della transazione o l'UID del conto, nonché uno screenshot dettagliato del trasferimento e un'identificazione personale valida",
    Nu41: "Clicca per sapere"
  },
  common: {
    logins: "Accesso...",
    login: "Login",
    register: "Iscrizione",
    loginregister: "Accedi/Registrati",
    logout: "Esci",
    tip: "Mancia",
    logintip: "per favore accedi prima",
    expect: "Attendo con ansia l'aspettativa!",
    delete: "Confermi l'eliminazione?",
    nodata: "Nessun record",
    set: "Impostato",
    update: "Modificare",
    slogan: "I 50 migliori scambi di valuta digitale del mondo",
    subslogan: "L'agenzia statale garantisce la sicurezza patrimoniale",
    more: "Di più",
    please: "Per favore",
    pleaseselect: "Selezionare",
    searchplaceholder: "Inserisci il simbolo della moneta...",
    searchplaceholderswap: "Inserisci il simbolo di scambio...",
    loading: "Caricamento...",
    close: "Vicino",
    ok: "OK",
    fillComplete: "Si prega di compilare le informazioni complete"
  },
  header: {
    index: "Casa",
    otc: "OTC",
    exchange: "Macchiare",
    xiaoxi: "Messaggio",
    kefu: "Aiuto",
    login: "LOGIN",
    register: "REGISTRO",
    asset: "RISORSA",
    otcOrder: "ORDINE",
    ucenter: "ACCOUNT",
    service: "Annuncio",
    downloadapp: "Scansiona il codice per il download e l'installazione",
    appdownlaod: "Scarica l'APP",
    usercenter: "Centro utenti",
    helpcenter: "CENTRO AIUTO",
    aboutus: "Di",
    partner: "Partner",
    bzb: "BZB ECO",
    assetmanage: "Finanza",
    trademanage: "Scambio",
    activity: "Fulmine",
    lab: "Laboratorio BIPPAX",
    ctc: "Scambio C2C",
    labdetail: "Laboratorio di fulmini BIPPAX",
    invite: "Socio Promotore",
    whitepaper: "Libro bianco",
    scandownload: "Scarica l'app",
    innovationmanage: "Innovazione",
    swap1: "Contrarre",
    swap2: "Scambia(Ex)",
    swap3: "CFD",
    swap4: "Secondo",
    cexchange: "QuikExchange",
    option: "Contratto di opzione",
    news: "Notizia"
  },
  sectionPage: {
    ptaqTitle: "Sicurezza della piattaforma",
    ptaqContent: "L'algoritmo hash viene utilizzato per crittografare l'autenticazione di sicurezza leader a livello mondiale",
    ptslTitle: "Forza della piattaforma",
    ptslContent: "La più grande piattaforma di trading di bitcoin al mondo",
    newsTitle: "Centro notizie",
    brandTitle: "A proposito di BIPPAX",
    brandDetail: "Onesto |  Giusto |  Entusiasmo |  Aprire",
    brandDesc1: "BIPPAX è stata fondata da un gruppo di primi partecipanti e fanatici di Bitcoin. I membri principali del team provengono da aziende rinomate come Google, Microsoft, Alibaba, Tencent e così via. Ha una profonda forza di ricerca e sviluppo e una ricca esperienza nel funzionamento dei prodotti Internet.",
    brandDesc2: "BIPPAX si trova nel fornitore di servizi di base della blockchain, dedicato a fornire una piattaforma di scambio di risorse crittografate di alta qualità per utenti globali, aderendo al principio di base di \"NON ESSERE EVIL\", sostenendo un servizio onesto, giusto ed entusiasta ai clienti e accogliendo tutti i partner/progetti vantaggiosi per gli interessi fondamentali degli utenti con un atteggiamento aperto.",
    gettingstart: "CALDO | Guida per principianti",
    officialstart: "Servizio clienti ufficiale BIPPAX",
    oneminutebuy: "Transazione valutaria",
    oneminutebuytips: "Utilizza una risorsa digitale per scambiarla direttamente con un'altra",
    baseknow: "Transazione contrattuale",
    baseknowtips: "T+0 scambio bidirezionale di beni virtuali come contratto di baratto",
    baseexchange: "Contratto di opzione",
    baseexchangetips: "È un derivato di asset digitali",
    usersocial: "Scambio rapido",
    usersocialtips: "Scambia rapidamente risorse digitali",
    mainboard: "Scheda principale",
    preview: "Precedente",
    nextpage: "Prossimo",
    downloadwhite: "Scarica il Libro bianco"
  },
  nav: {
    ptjy: "Commercio su piattaforma",
    ptaq: "Sicurezza della piattaforma",
    ptsl: "Forza della piattaforma",
    xwzx: "Centro notizie",
    fabu: "pubblicità"
  },
  progress: {
    already: "Devo scavare",
    total: "Quantità di minerale estraibile 6 miliardi di BHB"
  },
  service: {
    USDT: "USDT",
    BTC: "Bitcoin",
    ETH: "ET",
    CUSTOM: "Favore",
    COIN: "Coniare",
    symbol: "Coppia di transazioni",
    favor: "Favore",
    NewPrice: "Ultimo",
    ExchangeNum: "Quantità",
    Change: "Modifica",
    OpenPrice: "Prezzo aperto",
    PriceTrend: "Andamento dei prezzi",
    Operate: "Operare",
    Exchange: "Scambio",
    trading: "Scambio",
    high: "Più alto",
    low: "Inferiore"
  },
  swapAssets: {
    Br1: "Reso acquisto",
    Br2: "Acquista tramite abbonamento",
    Br3: "Trasferimento sul conto del contratto",
    Br4: "Trasferire il conto del contratto",
    Br5: "Profitti e perdite dei contratti perpetui",
    Br6: "FINE",
    Br7: "Conto contrattuale (standard U)",
    Br8: "Saldo del portafoglio",
    Br9: "Prezzo attuale",
    Br10: "Apri di più",
    Br11: "All'aria aperta",
    Br12: "Nascondi altri contratti",
    Br13: "Posizione di chiusura con un clic",
    Br14: "Annulla tutti gli ordini",
    Br15: "Correzione perpetua del saldo del contratto"
  },
  exchange: {
    wholehog: "Maiale intero",
    coin: "Coniare",
    symbol: "Coppia di transazioni",
    lastprice: "Ultimo",
    daychange: "Modifica",
    market: "Mercati",
    favorite: "Segnato",
    do_favorite: "Raccolto",
    cancel_favorite: "Annulla raccolto",
    type: "Tipo",
    dealamount: "Importo finale",
    high: "Alto",
    low: "Basso",
    vol: "24 ore vol",
    buy: "Acquistare",
    sell: "Vendere",
    limited_price: "Prezzo limitato",
    market_price: "Prezzo di mercato",
    fees_rate: "tariffa",
    balance: "equilibri",
    or: "O",
    starttrade: "Fai trading adesso!",
    canuse: "Disponibile",
    recharge: "Depositare",
    buyprice: "Prezzo d'acquisto",
    buynum: "Acquista importo",
    amount: "Quantità",
    buyin: "Acquistare",
    disablebuyin: "Acquisto sul mercato disabilitato",
    buytip: "Acquisto ottimale",
    sellprice: "Prezzo di vendita",
    sellnum: "Importo di vendita",
    sellout: "Vendere",
    disablesellout: "Vendita al mercato disabilitata",
    selltip: "Vendita ottimale",
    curdelegation: "Delegare",
    hisdelegation: "Delegato alla Storia",
    realtransaction: "Commerci di mercato",
    num: "Quantità",
    price: "Prezzo",
    direction: "Direzione",
    time: "Tempo",
    stall: "Stallo",
    total: "Totale",
    traded: "Fatto",
    action: "Azione",
    undo: "Disfare",
    delegationnum: "Importo delegato",
    done: "Fatto",
    status: "Stato",
    finished: "Finito",
    canceled: "Annullato",
    parted: "Separato",
    tip: "Mancia",
    buyamounttip: "inserisci l'importo di acquisto",
    buyamounttipwarning: "acquistare l'importo non di più",
    success: "invia successo!",
    pricetip: "inserisci il prezzo di acquisto",
    pricetipwarning: "prezzo di acquisto non di più",
    sellamounttip: "inserire l'importo di vendita",
    sellamounttipwarning: "vendere l'importo non di più",
    sellpricetip: "inserisci il prezzo di vendita",
    sellpricetipwarning: "prezzo di vendita non superiore",
    undotip: "Confermi Annulla?",
    cancelsuccess: "Annulla ordine riuscito",
    marketprice: "Prezzo di mercato",
    expand: {
      time: "tempo",
      price: "prezzo",
      amount: "quantità",
      fee: "tassa"
    },
    realtime: "tempo reale",
    kline: "KLine",
    depth: "Profondità",
    publishstate0: "Sta per iniziare. Attendere prego....",
    publishstate1: "Sta per finire. Attendere prego...",
    publishstate2: "Consolidamento ordine, attendere prego...",
    publishstate3: "Il consolidamento è finito, per favore commercia liberamente....",
    publishdetail: "Maggiori dettagli",
    publishprice: "Prezzo",
    publishamount: "Quantità",
    publishcounttxt0: "Inizia dopo",
    publishcounttxt1: "Fine dopo",
    publishcounttxt2: "Il libero scambio dopo",
    publishcounttxt3: "Attività terminata!",
    dateTimeDay: "D",
    dateTimeHour: "H",
    dateTimeMinutes: "M",
    dateTimeSeconds: "S",
    moredetail: "Visualizza altro"
  },
  swap: {
    Sw1: "Aumentare il margine",
    Sw2: "Ridurre il margine",
    Sw3: "Aumento",
    Sw4: "Ridurre",
    Sw5: "Margine",
    Sw6: "Massimo consentito",
    Sw7: "Il successivo livellamento forzato del prezzo è",
    Sw8: "Il rapporto di leva dopo è",
    Sw10: "Aumentare il margine contrattuale",
    Sw11: "Ridurre il margine contrattuale",
    Sw12: "Testo descrittivo",
    Spsl1: "Tempo di attivazione effettivo",
    Spsl2: "Numero effettivo di trigger",
    Spsl3: "Direzione effettiva di attivazione",
    Spsl4: "Prezzo di attivazione effettivo",
    contract: "Contrarre",
    swapindex: "Perpetuo",
    coin: "Coniare",
    symbol: "Coppia di monete",
    volume: "Volume",
    lastprice: "Ultimo",
    daychange: "Modifica",
    market: "Mercati",
    favorite: "Segnato",
    do_favorite: "Raccolto",
    cancel_favorite: "Annulla raccolto",
    type: "Tipo",
    dealamount: "Importo finale",
    high: "Alto",
    low: "Basso",
    vol: "24 ore vol",
    buy: "Acquistare",
    sell: "Vendere",
    limited_price: "Prezzo limitato",
    market_price: "Prezzo di mercato",
    spot_price: "Prezzo di attivazione",
    fees_rate: "tariffa",
    balance: "equilibri",
    or: "O",
    starttrade: "Fai trading adesso!",
    canuse: "Disponibile",
    recharge: "Depositare",
    buyprice: "Prezzo d'acquisto",
    buynum: "Acquista importo",
    amount: "Quantità",
    buyin: "Acquistare",
    disablebuyin: "Acquisto sul mercato disabilitato",
    buytip: "Acquisto ottimale",
    sellprice: "Prezzo di vendita",
    sellnum: "Importo di vendita",
    sellout: "Vendere",
    disablesellout: "Vendita al mercato disabilitata",
    selltip: "Vendita ottimale",
    curdelegation: "Delegare",
    hisdelegation: "Delegato alla Storia",
    realtransaction: "Commerci di mercato",
    num: "Quantità",
    price: "Prezzo",
    direction: "Direzione",
    time: "Tempo",
    stall: "Stallo",
    total: "Totale",
    traded: "Fatto",
    action: "Azione",
    undo: "Disfare",
    delegationnum: "Importo delegato",
    done: "Fatto",
    status: "Stato",
    finished: "Finito",
    canceled: "Annullato",
    parted: "Separato",
    tip: "Mancia",
    buyamounttip: "inserisci l'importo di acquisto",
    buyamounttipwarning: "acquistare l'importo non di più",
    success: "invia successo!",
    pricetip: "inserisci il prezzo di acquisto",
    pricetipwarning: "prezzo di acquisto non di più",
    sellamounttip: "inserire l'importo di vendita",
    sellamounttipwarning: "vendere l'importo non di più",
    sellpricetip: "inserisci il prezzo di vendita",
    sellpricetipwarning: "prezzo di vendita non superiore",
    undotip: "Confermi Annulla?",
    cancelsuccess: "Annulla ordine riuscito",
    marketprice: "Prezzo di mercato",
    expand: {
      time: "tempo",
      price: "prezzo",
      amount: "quantità",
      fee: "tassa"
    },
    realtime: "tempo reale",
    kline: "KLine",
    depth: "Profondità",
    open: "Aprire",
    close: "Vicino",
    latestdeal: "Ultimo affare",
    myswapaccount: "Il mio conto di scambio",
    accountmode: "Modello",
    accountmargin: "Leva",
    accountquanyi: "Equità",
    profitandloss: "Profitti/profitti non realizzati",
    principalAmount: "Utile. Margine",
    positionAmount: "Margine utilizzato",
    frozenAmount: "Margine congelato",
    principalRate: "Rapporto di margine",
    zijinhuazhuan: "Trasferire",
    up: "l",
    down: "S",
    canup: "Massimo. l",
    candown: "Massimo. S",
    cancloseup: "Massimo (S)",
    canclosedown: "Massimo(L)",
    openup: "Aperto a lungo",
    opendown: "Aperto corto",
    closeup: "Chiudi breve",
    closedown: "Chiudi a lungo",
    currentposition: "Posizioni aperte",
    assetsdetail: "Transazioni",
    marginMode1: "isolato",
    marginMode2: "Attraverso",
    modifyMarginModeTitle: "Modifica la modalità margine del conto",
    modifyLeverage: "Regola la leva finanziaria",
    moredetail: "Visualizza altro",
    shareNumber: "Continua",
    entrustprice: "Prezzo",
    triggleprice: "Grilletto",
    openvolume: "Volume lungo",
    closevolume: "Volume breve",
    triggleplaceholder: "Il prezzo predefinito è quello di mercato",
    marketpriceplaceholder: "Verrà scambiato al miglior prezzo",
    levmaxtip: "La leva finanziaria non dovrebbe essere superiore al massimo",
    levmintip: "La leva finanziaria non dovrebbe essere inferiore al minimo",
    marginModeSuccessTip: "Modifica il successo.",
    noenoughbalance: "Equilibrio insufficiente",
    pleaseinputopenvolume: "Il volume dovrebbe essere superiore a 0",
    pleaseinputcorrectopenvolume: "Inserisci il volume corretto",
    pleaseinputrightentrustprice: "Inserisci il prezzo corretto",
    noenoughposition: "Posizione insufficiente",
    pleaseinputclosevolume: "Il volume dovrebbe essere superiore a 0",
    pleaseinputcorrectclosevolume: "Inserisci il volume corretto",
    pos_Pl: "PL.",
    pos_Ratio: "Rapporto PL",
    pos_pos: "Posizione",
    pos_canClose: "Posizione di Ava",
    pos_openPrice: "Prezzo aperto",
    pos_leverage: "Leva",
    pos_margin: "Margine Cur",
    pos_mRatio: "Rapporto di margine",
    pos_cmRatio: "Rapporto di mantenimento",
    pos_long: "Lungo",
    pos_short: "Corto",
    ent_entrustType: "Apri/Chiudi",
    ent_direction: "Direzione",
    ent_type: "Tipo",
    ent_trigglePrice: "Prezzo di attivazione",
    ent_entrustPrice: "Affida il prezzo",
    ent_tradedPrice: "Prezzo negoziato",
    ent_margin: "Margine",
    ent_volume: "Volume",
    ent_status: "Stato",
    ent_status1: "Affidamento",
    ent_status2: "Annullato",
    ent_status3: "Affidamento fallito",
    ent_status4: "Scambiato",
    ent_statusblast: "Raffica",
    ent_pl: "P/L",
    ent_fee: "Tassa",
    triggerpriceshouldbigger: "Il prezzo di attivazione dovrebbe essere superiore a 0"
  },
  ctc: {
    title: "Vendita con un clic ● Garanzia della piattaforma ● Sicurezza",
    desc: "Le risorse crittografiche sono gestite da BIPPAX e l'accettante fornisce servizi di scambio per lo scambio.",
    buyin: "Acquistare",
    sell: "Vendere",
    buyprice: "Prezzo d'acquisto",
    sellprice: "Prezzo di vendita",
    buynum: "Acquista importo",
    sellnum: "Importo di vendita",
    payamount: "Pagamento",
    getamount: "Pagamento",
    avabalance: "Disponibile",
    time: "Data commerciale",
    tip: "Avviso",
    notice: "Avviso",
    notice1: "1. L'area di scambio valutario legale è una transazione patrimoniale tra utilizzatori e accettanti. I fondi non vengono trasferiti a una piattaforma e la piattaforma non accetta ricariche/rimesse in RMB;",
    notice2: "2. Gli accettatori di transazioni valutarie legali hanno superato la certificazione del nome reale, offrendo margini di transazione e i token sono ospitati sulla piattaforma, quindi puoi essere certo che possono essere convertiti;",
    notice3: "3. L'orario di servizio dell'accettatore è dalle 09:00 alle 21:00 al giorno. L'accettazione viene completata entro 30 minuti dall'accettazione dell'ordine e la transazione non completata di due ore viene annullata;",
    notice4: "4. Per supportare le carte bancarie nell'area di scambio di valuta legale, è necessario trasferire fondi utilizzando un conto autenticato con il tuo vero nome;",
    notice5: "5. Al fine di garantire la sicurezza dei fondi delle transazioni, la transazione in valuta legale richiede che gli utenti superino l'autenticazione del nome reale;",
    payType: "Pagare il conto",
    receiveType: "Ricevi conto",
    moneyTips: "Il prezzo sopra indicato è solo di riferimento. Si prega di fare riferimento all'importo effettivo della liquidazione dopo il seguente ordine.",
    verifyset: "Nome reale/Password risorsa",
    payset: "Impostazioni di pagamento",
    trade: "Scambio",
    input50tips: "Inserisci un numero compreso tra 50 e 50.000",
    bank: "Carta bancaria",
    alipay: "Alipay",
    wechatpay: "Wechat",
    payaccountset: "Impostazioni dell'account di pagamento",
    useselfaccount: "Assicurati di utilizzare il tuo account autenticato con il nome reale.",
    orderSn: "Ordine n.",
    tradetime: "Data di scambio",
    direction: "Direzione",
    amount: "Importo (USDT)",
    money: "Totale(CNY)",
    price: "Prezzo(CNY)",
    status: "Stato",
    operate: "Operare",
    moredetail: "Maggiori dettagli"
  },
  cexchange: {
    title: "Attività BZB",
    desc: "Moneta BZB ● Con un clic ● Guadagna ogni giorno",
    quantity: "AttivitàQuantità di acquisto",
    inputtips1: "Il numero di personalizzato",
    choosecurrency: "Scegli una valuta",
    all: "Tutto",
    totalpay: "Valuta Importo pagato",
    restricted: "Il totale limitato oggi",
    currentprice: "Prezzo attuale",
    nextprice: "Prezzo della prossima emissione",
    confirmpay: "Conferma il pagamento",
    assets: "Attività:",
    loginFirst: "Effettua il login",
    success: "Congratulazioni, scambio riuscito!",
    tip: "Suggerimenti",
    confirm: "Conferma i suggerimenti",
    confirmmsg: "Sei sicuro di scambiare BZB?",
    ok: "OK",
    cancel: "Cancellare"
  },
  subscribe: {
    Su1: "Pagina dei dettagli",
    Su2: "Sottoscrizione",
    Su3: "Nuova sottoscrizione di valuta",
    Su4: "Da iniziare",
    Su5: "In corso",
    Su6: "Da annunciare",
    Su7: "Distanza",
    Su8: "Inizio",
    Su9: "Prezzo di emissione",
    Su10: "Rapporto profitti e perdite attesi",
    Su11: "Ora di inizio",
    Su12: "Tempo di pubblicazione",
    Su13: "Dettagli",
    Su14: "Sottoscrizione",
    Su15: "Registro dell'abbonamento",
    Su16: "Nome della valuta",
    Su17: "Prezzo di emissione",
    Su18: "Prezzo di emissione",
    Su19: "Numero di offerte vincenti",
    Su20: "Importo del rimborso",
    Su21: "Tempo",
    Su22: "Stato",
    Su23: "Tempo",
    Su24: "Importo dell'abbonamento",
    Su25: "Valuta di sottoscrizione",
    Su26: "Prezzo di emissione",
    Su27: "Profitti e perdite attesi",
    Su28: "Limite di abbonamento",
    Su29: "Orario di inizio abbonamento",
    Su30: "Orario di fine abbonamento",
    Su31: "Momento di pubblicazione dei risultati",
    Su32: "Orario di lancio previsto",
    Su33: "Importo dell'abbonamento",
    Su34: "Valuta",
    Su35: "Importo dell'abbonamento",
    Su36: "Tempo di abbonamento",
    Su37: "Stato",
    Su38: "Da annunciare",
    Su39: "Pubblicato",
    Su40: "Informazioni sul progetto",
    Su41: "Saldo disponibile",
    Su42: "Applicare immediatamente",
    Su43: "Tutto",
    Su44: "Password di pagamento"
  },
  option: {
    minute: "min",
    enter: "Per favore entra",
    title: "Contratto di opzione",
    buyupreward: "Acquista un pool di premi",
    buydownreward: "Vendi un pool di premi",
    quantity: "Importo della scommessa",
    myamount: "L'importo della mia scommessa",
    buyup: "Rialzista",
    buydown: "Ribassista",
    history: "Storia",
    seriers: "NO.",
    period: "",
    currentoption: "Intervallo di tempo",
    openprice: "Prezzo aperto",
    currentprice: "Prezzo attuale",
    openprice1: "Prezzo aperto",
    closeprice: "Chiudi prezzo",
    opentime: "Orario di apertura",
    closetime: "Orario di chiusura",
    progress: "Progressi",
    loginFirst: "Effettua prima il login!",
    selectAmount: "Seleziona l'importo",
    balancenotenough: "Il saldo non basta!",
    betsuccess: "Congratulazioni! Scommetti con successo!",
    noopening: "Nessuna apertura adesso!",
    col_createTime: "Crea tempo",
    col_direction: "Direzione",
    col_result: "Risultato",
    col_optionNo: "NO.",
    col_betAmount: "Importo della scommessa",
    col_rewardAmount: "Importo della ricompensa",
    col_fee: "Tariffa aperta",
    col_winfee: "Commissione di ricompensa",
    win: "Vincita",
    lose: "Perdere",
    wait: "Apertura",
    avaliablebalance: "Saldo disponibile",
    login: "Effettua il login",
    kline: "Quotazioni in tempo reale",
    or1: "Harga terkini",
    or2: "Masa pertaruhan",
    or3: "Jumlah pertaruhan",
    or4: "Mata Wang Pertaruhan",
    or5: "Jumlah giaceva",
    or6: "Harga semasa è adalah harga pelaksanaan",
    or7: "Sejarah perdagangan",
    or8: "Probabilità",
    or9: "Bonus",
    or10: "Rekod perdagangan",
    or11: "Sila pila 4 giorni pertaruhan USDT yang biasa"
  },
  otc: {
    ad: "Pubblicità",
    buyin: "Acquistare",
    sellout: "Vendere",
    merchant: "Mercante",
    applymerchant: "Applica commerciante",
    volume: "Volume",
    paymethod: "Metodo di pagamento",
    amount: "Quantità",
    price_coin: "Prezzo/moneta",
    operate: "Azione",
    validate: "Per favore verifica prima",
    sell: "vendere",
    buy: "acquistare",
    transaction: "Transazioni commerciali",
    buttontxt: "Diventa commerciante",
    title: "Borsa OTC",
    desc: "Vendita conveniente, sicura e veloce di valuta digitale",
    title1: "Accordatura dinamica",
    desc1: "Fluttuazione in tempo reale in base al prezzo di mercato",
    title2: "Nessuna commissione",
    desc2: "Ciò che vedi è ciò che ottieni. Oltre al prezzo di vendita, non sono previsti costi di servizio per la piattaforma",
    title3: "Transazione immediata",
    desc3: "L'introduzione di servizi di piattaforma per commercianti, abbinamento intelligente, chiusura degli ordini, nessuna necessità di attendere il matchmaking",
    title4: "Garanzia della piattaforma",
    desc4: "Attività di certificazione della piattaforma, sicurezza garantita, servizio clienti 24 ore su 24 per l'accompagnatore della transazione",
    myad: {
      title: "Il mio annuncio",
      post: "Pubblica un annuncio",
      alert: "【Suggerimento】：Quando l'importo minimo degli acquisti pubblicitari più la tariffa è superiore al numero rimanente di annunci, l'annuncio viene automaticamente rimosso dallo scaffale.",
      no: "NO",
      type: "tipo",
      sell: "vendere",
      buy: "acquistare",
      limit: "limite",
      remain: "importo rimanente",
      coin: "coniare",
      created: "data di creazione",
      operate: "azione",
      errmsg: "Può essere modificato e modificato dopo che l'annuncio è stato disattivato",
      update: "modificare",
      shelf: "mensola",
      dropoff: "consegna",
      delete: "eliminare"
    },
    myorder: "Il mio ordine",
    chatline: {
      status_1: "L'acquirente non ha pagato e ha aspettato che pagasse l'acquirente!",
      status_2: "L'acquirente ha pagato e attende il rilascio da parte del venditore!",
      status_3: "Transazione completata dell'ordine!",
      status_4: "L'ordinanza è in appello!",
      status_5: "Ordine annullato!",
      loadmore: "Carica di più",
      warning: "Avvisi antifrode: nel recente passato, i truffatori hanno utilizzato ripetutamente informazioni sulle rimesse dei bonifici bancari e false credenziali di rimessa per frode, quindi assicurati di controllare il numero del tuo conto di pagamento. Garantire la sicurezza dei fondi delle rimesse ed evitare il rischio che le carte bancarie vengano congelate!",
      contenttip: "Inserisci il contenuto della chat. Inserisci la chiave per inviare",
      contentmsg: "Il messaggio non può essere vuoto"
    },
    chat: {
      seller: "Venditore",
      buyer: "Acquirente",
      exchangeamount: "Importo del cambio",
      operatetip: "Azionare la punta",
      operatetip_1: "Si prega di completare il pagamento secondo il conto fornito dalla controparte entro il termine e fare clic su questa pagina.",
      finishpayment: "pagamento completato",
      operatetip_1_1: "Si prega di notare nei commenti quando si trasferisce il numero di riferimento del buon pagamento",
      operatetip_1_2: "Dopo aver ricevuto il pagamento, il venditore confermerà il pagamento sul sito web. Il sistema invierà automaticamente le risorse digitali che hai acquistato al tuo account. Tienilo presente",
      note: "Nota",
      notetip: "Ti preghiamo di non utilizzare altri software di chat per comunicare tra loro e di non accettare documenti, allegati email, ecc. inviati dalla direzione. Tutti i collegamenti di comunicazione vengono completati nella finestra di chat in questa pagina.",
      operatetip_2_1: "Le risorse digitali che hai venduto sono state inviate alla piattaforma per l'hosting e il congelamento. Hai confermato il pagamento, fai clic su",
      operatetip_2_2: "Si prega di non credere ad alcun motivo per sollecitare il rilascio della valuta, confermare la ricezione del denaro e rilasciare le risorse digitali per evitare perdite!",
      operatetip_2_3: "Dopo aver ricevuto il breve messaggio sull'account, assicurati di accedere all'online banking o al mobile banking per confermare se il pagamento è stato contabilizzato, per evitare il falso rilascio di risorse digitali a causa della ricezione di messaggi fraudolenti!",
      confirmrelease: "Conferma il rilascio",
      paydigital: "Pagare le risorse digitali",
      orderstatus: "Stato dell'ordine",
      orderstatus_1: "pagamento completato",
      orderstatus_2: "Ricorso d'ordinanza",
      orderstatus_3: "Conferma il rilascio",
      orderstatus_4: "annullare l'accordo",
      orderstatus_5: "Ricorso d'ordinanza",
      order: "Ordine",
      and: "E",
      transition: "scambio",
      transprice: "Prezzo di negoziazione",
      transnum: "Numero di scambi",
      transmoney: "Importo negoziabile",
      tip1: "L'utente non ha ancora aggiunto il numero della carta bancaria",
      tip2: "L'utente non ha aggiunto il conto Alipay per il momento",
      tip3: "L'utente non ha ancora aggiunto l'account WeChat",
      zfb: "Alipay",
      wx: "WeChat",
      qrcode: "Codice QR",
      msg1: "Sei sicuro di aver pagato?",
      msg2: "I pagamenti non sono rimborsabili! Sei sicuro di voler annullare il tuo ordine?",
      msg3: "【Ripeti】：I pagamenti non sono rimborsabili!Sei sicuro di voler annullare il tuo ordine?",
      msg4: "Pagato, non ricevuto",
      msg5: "Già pagato, non ricevuto",
      tip: "Mancia",
      comptype: "Tipo di reclamo",
      compremark: "Nota di reclamo",
      willcomp: "Voglio lamentarmi",
      msg6: "Confermi il rilascio della valuta?",
      result_1: "in attesa del pagamento",
      result_2: "In attesa di rilascio",
      result_3: "Completato",
      result_4: "Attraente",
      result_5: "Annullato",
      msg7: "Password del fondo",
      msg7tip: "inserisci la password del fondo"
    },
    checkuser: {
      emaildone: "E-mail certificata",
      emailundo: "E-mail non autorizzata",
      teldone: "Certificato Telno",
      telundo: "Telno non autorizzato",
      idcarddone: "Certificato carta d'identità",
      idcardundo: "Carta d'identità non autorizzata",
      language: "lingua",
      languagetext: "cinese",
      registtime: "Orario di registrazione",
      exchangetimes: "Transazioni accumulate",
      exchangeinfo: "Informazioni commerciali",
      tablabel1: "Vendere on-line",
      tablabel2: "Acquista on-line",
      col_symbol: "Coniare",
      col_paymode: "Metodo di pagamento",
      col_num: "Quantità",
      col_price: "Prezzo",
      col_created: "Tempo di rilascio",
      col_operate: "Operare",
      operatemsg: "Eseguire prima l'autenticazione del nome reale",
      buyin: "Acquista",
      sellout: "Tutto esaurito"
    },
    tradecenter: {
      postad: "Pubblica un annuncio",
      exchange: "Transazione GCC",
      buyin: "Voglio comprare",
      sellout: "Voglio tutto esaurito"
    },
    tradeinfo: {
      emaildone: "E-mail certificata",
      emailundo: "E-mail non autorizzata",
      teldone: "Certificato Telno",
      telundo: "Telno non autorizzato",
      idcarddone: "Certificato carta d'identità",
      idcardundo: "Carta d'identità non autorizzata",
      exchangetimes: "Tempi di scambio",
      price: "Prezzo",
      num: "Quantità",
      paymethod: "Metodo di pagamento",
      exchangelimitamount: "Limite di scambio",
      location: "Posizione",
      location_text: "Cina",
      exchangeperiod: "Periodo di scambio",
      minute: "min",
      amounttip: "Inserisci l'importo",
      numtip: "Per favore inserisci il num",
      remarktip: "Raccontagli la tua richiesta",
      remarktitle: "Osservazioni sull'orizzonte",
      exchangetitle: "Informazioni commerciali",
      exchange_tip1: "Dopo aver avviato la richiesta di transazione, la valuta digitale viene bloccata nell'hosting e protetta dalla piattaforma. Se sei un venditore, dopo aver avviato una richiesta di transazione, puoi ricaricare e attendere il pagamento da parte dell'acquirente. Gli acquirenti pagano entro il termine di pagamento. Dopo aver ricevuto il pagamento, dovresti rilasciare la valuta digitale che è sotto la tua custodia.",
      exchange_tip2: "Prima di fare trading, leggi i 《Termini di servizio della rete di piattaforme》 e le domande frequenti, le guide al trading e altra documentazione di aiuto.",
      exchange_tip3: "Attenti ai bugiardi!Prima della transazione verificate la valutazione ricevuta dall'utente e prestate maggiore attenzione all'account appena creato.",
      exchange_tip4: "Tieni presente che gli arrotondamenti e le fluttuazioni dei prezzi possono influire sulla quantità di valuta digitale che viene eventualmente scambiata. L'importo fisso inserito determina l'importo finale e l'importo della valuta digitale verrà calcolato dal tasso di cambio istantaneo nello stesso momento in cui viene emessa la richiesta.",
      exchange_tip5: "I servizi di hosting proteggono sia gli acquirenti che i venditori di transazioni online. In caso di controversia, valuteremo tutte le informazioni fornite e rilasceremo la valuta digitale ospitata al suo legittimo proprietario.",
      warning1: "Inserisci fino a 2 cifre decimali",
      warning2: "L'importo dell'ordine è",
      warning3: "Inserisci fino a 8 cifre decimali",
      warning4: "La quantità dell'ordine è",
      confirmbuyin: "Conferma l'acquisto",
      confirmsellout: "Conferma la vendita",
      buyin: "Acquista",
      sellout: "Tutto esaurito",
      warning5: "Si prega di compilare l'ordine come richiesto"
    },
    publishad: {
      createad: "Crea un accordo pubblicitario",
      msg1: "Se fai trading spesso, puoi creare il tuo annuncio di trading. Se fai trading solo occasionalmente, ti consigliamo di cercare direttamente",
      msg2: "Creare un annuncio commerciale è",
      msg3: "Gratuito",
      msg4: "Se desideri modificare direttamente gli annunci creati, controlla",
      tradead: "Pubblicità commerciale",
      myad: "La mia pubblicità",
      iwant: "Voglio",
      sellonline: "vendere on-line",
      buyonline: "acquistare on-line",
      exchangecoin: "Scambia moneta",
      country: "Paese",
      currency: "Coniare",
      openfixedprice: "Prezzo fisso aperto",
      open: "Aprire",
      close: "Vicino",
      usetip: "Se abilitato, il prezzo della tua valuta non oscillerà con il mercato e il prezzo non cambierà.",
      premiseprice: "Premio",
      premisepricetip: "Imposta il tuo premio",
      fixedprice: "prezzo fisso",
      fixedpricetip: "Inserisci il prezzo di scambio",
      marketprice: "Prezzo di riferimento del mercato",
      marketpricetip: "Il premio si riferisce alla percentuale superiore al prezzo di mercato corrente",
      exchangeprice: "Prezzo di scambio",
      formual: "Formula di prezzo",
      num: "Quantità",
      num_text1: "Per favore inserisci quello che vuoi",
      num_text2: "numero",
      exchangeperiod: "Periodo della transazione",
      exchangeperiod_text1: "Inserisci la scadenza per il trading",
      minute: "min",
      tip1: "Per quanto tempo l'acquirente può accettare le transazioni, inserisci un numero intero",
      tip2: "【Suggerimento】Può essere associato al centro personale/Aggiungi metodo di pagamento",
      tip3: "Inserisci l'importo minimo della transazione",
      tip4: "Inserisci l'importo massimo della transazione",
      tip5: "Puoi inserire i tuoi requisiti speciali nelle informazioni sui commenti, ad esempio: requisiti dell'acquirente, tempo online e così via.",
      paymode: "Metodo di pagamento",
      minlimit: "Importo minimo della transazione",
      maxlimit: "Importo massimo della transazione",
      remark: "Osservazioni",
      openautoreply: "Apri la risposta automatica",
      msg5: "Se abilitato, quando l'utente avvia una transazione tramite questo annuncio, il sistema invia automaticamente all'altra parte la frase di risposta automatica selezionata.",
      autoreply: "Risposta automatica",
      autoreplytip: "Dopo aver ricevuto l'ordine, le informazioni vengono automaticamente restituite all'acquirente, ad esempio: metodo di pagamento, numero del conto di ritiro, ecc.",
      fundpwd: "Password del fondo",
      fundpwdtip: "Inserisci la password dei tuoi fondi",
      submit: "Invia",
      warning1: "Inserisci il numero corretto",
      warning2: "Il valore di overflow è 0-20",
      warning3: "Inserisci l'importo massimo della transazione!",
      warning4: "Inserisci un numero intero",
      warning5: "L'importo massimo della transazione deve essere maggiore dell'importo minimo della transazione!",
      warning6: "L'importo massimo della transazione non può superare l'importo totale della vendita",
      warning7: "Inserisci l'importo minimo della transazione!",
      warning8: "L'importo minimo della transazione deve essere maggiore o uguale a 100!",
      warning9: "L'importo minimo della transazione deve essere inferiore all'importo massimo della transazione",
      sellout: "Vendere",
      buyin: "Acquistare",
      inputtip1: "Inserisci la valuta",
      inputtip2: "Inserisci l'opzione corretta",
      inputtip3: "Il valore di overflow è 0-20 e non può essere 0",
      inputtip4: "Inserisci il prezzo fisso corretto",
      inputtip5: "Inserisci il numero corretto e il numero massimo di transazioni non supera 100",
      inputtip6: "Inserisci la scadenza di negoziazione corretta",
      inputtip7: "Seleziona il metodo di transazione",
      inputtip8: "Inserisci la password dei fondi",
      zfb: "Alipay",
      wx: "Wechat",
      unionpay: "UnionPay",
      submit_failure: "Fallimento!",
      submittip1: "Si prega di procedere con una serie di certificazioni come i nomi reali",
      submittip2: "Si prega di condurre una serie di certificazioni come i telefoni cellulari",
      submittip3: "Si prega di procedere con una serie di certificazioni come le password maiuscole",
      submittip4: "Associa almeno un metodo di pagamento"
    },
    index: {
      title: "Buona raccomandazione pubblicitaria",
      exchangetimes: "Tempi di transazione",
      exchangeprice: "Prezzo della transazione",
      exchangelimit: "Limite di transazione",
      paymode: "Metodo di pagamento",
      buy: "acquistare",
      sell: "vendere",
      viewmore: "Di più",
      bot1: "Sicuro e affidabile",
      bot1_tip: "Oltre 10 anni di esperienza nel team di controllo del rischio finanziario\nSistema di politiche di sicurezza personalizzabile",
      bot2: "Veloce e facile",
      bot2_tip: "Supporto per la modalità di transazione gratuita per utenti peer-to-peer\nTipi di canali di scambio di denaro",
      bot3: "Valuta completa",
      bot3_tip: "Selezione delle principali valute per le transazioni di asset digitali\nEsperienza di trading multi-asset",
      ibuy: "Voglio comprare",
      isell: "Voglio vendere"
    }
  },
  activity: {
    all: "Tutto",
    prepare: "In arrivo",
    ongoing: "In corso",
    distributing: "Distribuire",
    completed: "Completato",
    progress: "Progressi",
    totalsupply: "Fornitura totale",
    starttime: "Data di inizio",
    endtime: "Data di fine",
    viewdetail: "Dettaglio",
    attend: "Assistere",
    tokendistribute: "Distribuzione di token",
    baseinfo: "Informazioni sull'attività",
    status: "Stato",
    activitytype: "Tipo di attività",
    activitytype0: "Sconosciuto",
    activitytype1: "Elenco(FOF)",
    activitytype2: "Elenco(AVA)",
    activitytype3: "HolderDivide",
    activitytype4: "Acquista gratuitamente",
    activitytype5: "MinerarioAcquista",
    activitytype6: "Bloccato",
    ruledetail: "A proposito di regola",
    publishprice: "Pubblica il prezzo",
    activitycoin: "Simbolo della moneta di attività",
    accpetcoin: "Accetta il simbolo della moneta",
    holdcoin: "Tieni premuto il simbolo della moneta",
    limittimes: "Tempi limite personali",
    limitamount: "Importo limite personale",
    unlimited: "Illimitato",
    alreadyamount: "Importo già venduto",
    leftamount: "Importo sinistro",
    attention: "Attenzione",
    attentiontxt1: "1、Le risorse verranno congelate dopo la richiesta di partecipazione ad attività di tipo [partizionamento del magazzino] e [abbonamento gratuito] fino al completamento dello scongelamento.",
    attentiontxt2: "2、Gli utenti non possono ritirare la propria domanda di partecipazione dopo aver partecipato ad attività del tipo 'Holder Divide' e 'Fress Buy'",
    attentiontxt3: "3、Se l'attività viene annullata a causa della parte coinvolta nel progetto e di altri fattori di forza maggiore, il percorso originale verrà restituito ai beni congelati.",
    attentiontxt4: "* Il diritto di interpretazione finale di questa attività appartiene alla proprietà ufficiale di BIPPAX.",
    inputamount: "Importo immesso",
    inputholdamount: "Importo blocco input",
    mybalance: "Saldo disponibile",
    holdtips: "[HolderDivide] richiede il blocco fino alla fine dell'attività.",
    pleaseinputamount: "Inserisci l'importo!",
    pleaseinputholdamount: "Inserisci l'importo da trattenere!",
    commitfailed: "Commit non riuscito!",
    minlimitamountfailed: "La quantità di scambio non deve essere inferiore all'importo minimo di scambio.!",
    maxlimitamountfailed: "L'importo dello scambio non dovrà essere superiore all'importo massimo di acquisto.!",
    limittimesfailed: "Hai partecipato a un numero di acquisti individuali superiore al numero massimo consentito.",
    balancenotenough: "L’equilibrio non è sufficiente!",
    headertitledesc: "Laboratori aperti per una cooperazione vantaggiosa tra investitori, proiettori e borse",
    currentdivided: "La mia posizione attuale otterrà",
    leveloneCount: "Limita il conteggio di livello uno",
    submit: "Invia",
    tipsmobile: "Si prega di utilizzare il sito web del PC（www.BIPPAX.com）",
    tipsmobile1: "È possibile accedere al Web del PC per partecipare a questa attività.",
    intvalue: "Per favore inserisci un valore intero",
    inputminingamount: "Inserisci il conteggio degli acquisti",
    moreactivity: "Altre attività",
    releaseType: "Tipo di rilascio",
    releaseType0: "Uguale rilascio",
    releaseType1: "Rilascio isometrico",
    lock: "Serratura",
    releaseDetail: "Dettagli del rilascio",
    lockday: "Giorni",
    lockweek: "Settimane",
    lockmonth: "Mesi",
    lockyear: "Anni",
    releasePercent: "Percentuale di rilascio",
    lockFee: "Tariffa di blocco",
    releaseTimes: "Tempi di rilascio",
    times: "volte"
  },
  invite: {
    myinvitelink: "Collegamento alla promozione",
    copy: "Copia",
    copyed: "Copiato",
    mylevelone: "Amici di primo livello",
    myleveltwo: "Amici di secondo livello",
    mycommission: "Commissioni attive (USDT)",
    extrareward: "Premi aggiuntivi",
    partnerlevel: "Livello di partenariato",
    ruledetail: "Dettagli della regola",
    ruleprofile1: "[Partner di promozione] rappresenta la percentuale più alta di restituzione della commissione online e il tempo di restituzione della commissione più lungo (commissione massima a vita). I promotori che compiono sforzi corrispondenti possono diventare veri e propri “partner” della piattaforma e godere del dividendo di crescere insieme alla piattaforma di trading BIPPAX. Le regole dettagliate sono le seguenti:",
    ruleprofile2: "",
    ruleprofile3: "",
    ruleprofile4: "",
    ruletext1: "1、Per predicare il concetto di risorse digitali ed espandere la portata degli utenti, BIPPAX ha lanciato il programma \"Promotion Partner\", che è efficace da molto tempo.",
    ruletext2: "2、L'invito agli amici può essere diviso in due livelli. Se A invita B, allora B è l'amico di primo livello di A. Se B invita C, allora C appartiene all'amico di primo livello di B e anche all'amico di secondo livello di A.",
    ruletext3: "3、Quando si promuove la registrazione degli amici, gli amici di primo livello degli invitanti possono essere solo amici di primo livello degli invitanti tramite i link forniti dagli invitanti o inserendo manualmente i codici di invito degli invitanti.",
    ruletext4: "4、Dopo che l'invitato si è registrato con il codice di invito dell'invitante e ha completato la certificazione del nome reale, l'incentivo della Commissione avrà effetto.",
    ruletext5: "5、Il tempo della commissione è di N mesi dall'inizio della certificazione del nome reale dell'invitato. A seconda dei diversi gradi, la percentuale della provvigione percepita è diversa.",
    ruletext6: "6、La promozione delle attività di commissione è la commissione di transazione della valuta amica di livello inferiore, ovvero le tre valute di base del mercato, vale a dire USDT, BTC ed ETH.",
    ruletext7: "7、La proporzione e la durata della commissione di promozione sono correlate positivamente al numero di amici di primo livello. Maggiore è il numero di promozioni, maggiore è la percentuale di commissioni piacevoli. La promozione specifica del rapporto di sconto delle commissioni è la seguente:",
    ruletext8: "8、TOP10 o TOP100 riceveranno di tanto in tanto incentivi aggiuntivi da MKWORLDS.",
    ruletext9: "9、Se altre attività sono in conflitto con le attività del Partner di Promozione, i Partner dovranno capire se cambiare temporaneamente dopo la consultazione.",
    ruletext10: "10、I partner a livello di inviato L4(Xunfu), L5(Taishou) e L6(Jiedushi) hanno diritto rispettivamente a bonus del 5%, 10% e 15% del rendimento annuale totale della Commissione.",
    ruletext11: "11、Il diritto di interpretazione finale di questa attività appartiene a BIPPAX.",
    ruleexampletitle: "Per esempio:",
    ruleexamplecontent1: "Se l'utente Xiaoyan invitava 100 amici di prima classe, gli amici di prima classe di TA invitavano cinque amici di seconda classe, allora Xiaoyan aveva 100 amici di prima classe e 500 amici di seconda classe. Se la persona media scambia 3000 yuan al giorno, il reddito mensile di Xiaoyan è di circa (100 * 3000 * 0,001 * 30% + 500 * 3000 * 0,001 * 10%)* 30 = 7200 / mese.",
    ruleexamplecontent2: "Se l'utente Xiaoyan invitava 1000 amici di prima classe, gli amici di prima classe di TA invitavano 5 amici di seconda classe, Xiaoyan aveva 1000 amici di prima classe e 5000 amici di seconda classe. Se la persona media scambia 3000 yuan al giorno, il reddito mensile di Xiaoyan è di circa (1000*3000*0,001*50%+5000*3000*0,001*20%)*30=135000/mese.",
    lastupdate: "Ultimo aggiornamento in",
    laststastic: "Ultima statistica entrata",
    level: "Livello",
    lv1: "Lizheng",
    lv2: "Xianling",
    lv3: "Zhifu",
    lv4: "Xunfu",
    lv5: "Taishou",
    lv6: "Jiedushi",
    levelonecount: "Numero di livello uno",
    levelonecommission: "Rapporto di rendimento di primo livello/Tempo di ritorno",
    leveltwocommission: "Rapporto di rendimento/tempo di ritorno di livello due",
    partnerdivide: "Dividendo del socio",
    month: "Mesi",
    alllife: "Tutta la vita",
    totalcommissionrank: "Promozione della Commissione totale",
    rank: "NO.",
    userid: "ID utente",
    rankday: "(Giorno)",
    rankweek: "(Settimana)",
    rankmonth: "(Mese)",
    rankall: "(Tutto)",
    promotioncount: "Numero di promozioni",
    commissionusdt: "Commissione (USDT)",
    ranktip1: "Il numero di inviti è il numero di amici di prima classe. Questo elenco classifica l'importo totale delle commissioni da grande a piccolo.",
    ranktip2: "Il numero di inviti è il numero di amici di prima classe. L'elenco è classificato in base al numero di amici di prima classe invitati.",
    thanks: "Grazie per aver supportato BIPPAX!",
    headertip: "I dati sopra riportati non sono aggiornati in tempo reale. Il sistema statistica e aggiorna ogni 24 ore.",
    ptools: "Strumenti di promozione",
    pt_title: "Carta regalo in criptovaluta",
    pt_desc: "Questa è una sorpresa dal futuro, da inviare ad amici, parenti, clienti, partner.",
    pt_more: "Sono in arrivo altri strumenti",
    pt_tips: "Se hai una buona idea, invia un'e-mail a Promotion@BIPPAX.com, con una ricompensa dopo l'adozione.!",
    pt_card_amount: "Importo della carta",
    pt_card_deadline: "Scadenza",
    pt_card_noend: "Indefinito",
    pt_card_btn: "Ottieni 30 carte gratuitamente (≈2000 CNY)",
    pt_card_btn_login: "Effettua prima l'accesso",
    pt_card_rule: "Dettagli della regola",
    pt_card_summary: "La carta regalo in valuta digitale è uno strumento promozionale sviluppato per consentire ai partner promozionali di invitare meglio gli amici offline. Quando gli utenti si scambiano le carte regalo, diventeranno automaticamente amici offline dei partner promozionali.",
    pt_card_rule1: "1. Le carte regalo gratuite sono limitate a 30 carte per utente. Se è necessario emettere più carte regalo, gli utenti devono pagare per la personalizzazione, che può personalizzare la quantità di carte, LOGO, istruzioni, ecc. Per requisiti personalizzati, inviare un'e-mail a",
    pt_card_rule2: "2. Le carte regalo gratuite sono limitate a una copia per utente. Le carte regalo gratuite emesse dal governo BIPPAX sono limitate a una per ciascun utente. Anche se diversi utenti ricevono buoni regalo gratuiti con codici di scambio diversi, è possibile scambiarne solo uno. Le carte regalo personalizzate non sono soggette a questa restrizione.",
    pt_card_rule3: "3. Prima che l'utente scambi la carta regalo, se non è presente un 'invitante' (ovvero non è stato inserito il codice invito al momento della registrazione dell'account), questa verrà automaticamente associata all'amico di primo livello dell'emittente della carta. Se A non inserisce un codice invito al momento della registrazione di un account, allora A non appartiene a nessuno degli amici di primo o secondo livello, ma quando A viene convertito in amici di primo livello di B attraverso la carta regalo emessa da B, A diventa automaticamente amico di primo livello di B.",
    pt_card_rule4: "4. Per evitare lo spazzolamento, il valore contabile delle carte regalo non viene pagato in tempo reale. Verrà congelato per 180 giorni dopo la raccolta e rilasciato automaticamente nel saldo dell'account utente dopo 180 giorni.",
    pt_card_rule5: "5. Quando riceviamo buoni regalo gratuiti, dobbiamo completare la certificazione del nome reale. Durante la conversione, possiamo ottenerli senza completare la certificazione del nome reale. Questo per facilitare ai promotori di ottenere amici di livello inferiore più velocemente.",
    pt_card_rule6: "6. Il diritto di interpretazione finale dei buoni regalo gratuiti appartiene a BIPPAX.PRO.",
    pt_card_day: "Giorni",
    pt_card_title_tips: "Sovvenzione promozionale gratuita di 2000 CNY",
    pt_card_receivew_success: "Congratulazioni! Raccolta riuscita di buoni regalo per la promozione dei partner! Vai al Centro personale -> Centro carte e voucher.",
    usepromotion: "Utilizza materiali promozionali",
    saveimage: "Salva immagine",
    imagetips: "Se non riesci a scaricare le immagini correttamente, scaricale utilizzando lo strumento screenshot!",
    pt_invite_title: "Opuscolo per la registrazione dell'invito",
    pt_invite_desc: "Diventate automaticamente amici subordinati attraverso la registrazione del codice bidimensionale, adatto per l'inoltro in vari gruppi o forum.",
    colum_text0: "Rango",
    colum_text1: "Membro",
    colum_text2: "Promozione",
    colum_text3: "Commissione (USDT)",
    colum_text4: "Premio extra",
    context_title: "Codice di riscatto esclusivo per i partner promozionali",
    context_title1: "Scansiona per saperne di più",
    context_title2: "Il mio codice di invito",
    context_title3: "Immagine di invito"
  },
  uc: {
    verify: "Completa prima il KYC",
    login: {
      noaccount: "Nessun account？",
      register: "Iscrizione",
      login: "Login",
      welcomelogin: "Benvenuto",
      usertip: "Inserisci l'e-mail",
      pwdtip: "Inserisci la password",
      validatecodeload: "Caricamento del codice di verifica",
      validatemsg: "Per favore completa prima la verifica",
      forget: "Hai dimenticato la password?",
      loginvalidate: "Inserisci l'e-mail o il numero di telefono",
      pwdvalidate1: "Per favore inserisci la password",
      pwdvalidate2: "Lunghezza della password non inferiore a sei",
      success: "Successo",
      goregister: "Per registrarsi",
      getlostpwd: "Dimentica la password"
    },
    forget: {
      title: "Trova la password",
      hasaccount: "Avere un account？Per accedere",
      login: "Login",
      sendcode: "Inviare",
      newpwd: "Inserisci la nuova password",
      confirmpwd: "Immettere nuovamente la nuova password",
      save: "Invia",
      pwdvalidate1: "Inserisci la password di conferma",
      pwdvalidate2: "La password non è la stessa!",
      resettelpwd: "Reimposta la password del telefono",
      resetemailpwd: "Reimposta la password dell'e-mail",
      newpwdtip: "Inserisci la nuova password",
      pwdvalidate3: "Lunghezza della password non inferiore a sei",
      telno: "Numero di telefono",
      mtelno: "Autenticazione del telefono cellulare",
      memail: "Autenticazione della casella di posta",
      smscode: "Codice di verifica tramite SMS",
      teltip: "Inserisci tel",
      smscodetip: "Inserisci il codice di verifica via SMS",
      email: "E-mail",
      emailcode: "Codice di verifica e-mail",
      emailtip: "Inserisci l'e-mail",
      emailcodetip: "Inserisci il codice di verifica e-mail",
      resetpwdsuccess: "Reimpostazione della password riuscita",
      smswarn: "Si prega di verificare la presenza di SMS"
    },
    finance: {
      fi1: "Verstecke kleine Vermögenswerte",
      center: "Centro finanziario",
      personalassets: "Attività valutarie",
      swapassets: "Scambiare risorse",
      billdetail: "Dettaglio fattura",
      charge: "Depositare",
      pickup: "Ritiro",
      tradetail: "Estrazione commerciale",
      paydividends: "Pagare i dividendi",
      invitingmining: "Invito ai premi minerari",
      money: {
        M1: "Quantità ricevuta",
        M2: "Trasferire la quantità",
        M3: "Tasso di cambio",
        cointype: "Coniare",
        balance: "Bilancia",
        frozen: "Equilibrio congelato",
        operate: "Azione",
        charge: "Depositare",
        pickup: "Ritiro",
        onkeytrans: "Trans",
        getaddress: "Ottieni indirizzo",
        resetsuccess: "Reimposta successo",
        match: "Incontro",
        matchtip1: "Importo GCX corrispondente disponibile",
        matchtip2: "Inserisci l'importo della corrispondenza",
        matcherr1: "Inserisci una quantità valida!",
        matcherr2: "Supera il numero massimo di partite!",
        matchsuccess: "Partita di successo!",
        needreleased: "Beni da liberare",
        totalassets: "Valore totale stimato delle attività:"
      },
      swap: {
        totalassets: "Valore totale stimato delle attività:",
        swap: "Scambio",
        swaptype: "SCAMBIO",
        swapassets: "Equità del conto",
        avabalance: "Margine di Avali",
        usebalance: "Margine utilizzato",
        frozenbalance: "Margine congelato",
        profitandloss: "Pl. non realizzato",
        transfor: "Trasferire",
        inputtransferamount: "Importo del trasferimento",
        all: "Tutto",
        currencyaccount: "Conto spot",
        swapaccount: "Conto swap perpetuo",
        clickchange: "Fare clic per cambiare direzione",
        avaamount: "Disponibile",
        pleaseselectwallet: "Scegli un portafoglio di trasferimento.",
        pleaseinputamount: "Inserisci l'importo del trasferimento",
        oktransfer: "Trasferisci adesso"
      },
      trade: {
        start_end: "Inizio-Fine",
        account_date: "Tempo per ricevere il capitale",
        to: "A",
        operatetype: "Tipo di azione",
        search: "Ricerca",
        charge: "Carica",
        pickup: "Raccolta",
        transaccount: "Trasferire",
        exchange: "Scambio",
        otcbuy: "OTC-Acquista",
        otcsell: "Vendita OTC",
        activityaward: "Premio Attività",
        promotionaward: "Premio Promozione",
        dividend: "Dividendo",
        vote: "Votare",
        handrecharge: "Ricarica artificiale",
        match: "Incontro",
        activitybuy: "Attività Acquista",
        ctcbuy: "CTC-Acquista",
        ctcsell: "CTC-Vendi",
        chargetime: "tempo di generazione dell'ordine",
        type: "Tipo",
        num: "Quantità",
        status: "Stato",
        finish: "Finito",
        fee: "Restituzione delle tasse minerarie",
        transactionTime: "Tempo di negoziazione",
        symbol: "Coppia di monete",
        direction: "Direzione",
        price: "Prezzo",
        entrustment: "Affidamento",
        havedeal: "Ho concluso un accordo",
        poundageAmount: "Servizio",
        exchangeOrderId: "L'ID dell'ordine",
        mineAmount: "Scava una valuta (BHB)",
        buy: "ACQUISTARE",
        sell: "VENDERE",
        limit: "LIMITE",
        market: "MERCATO",
        clear: "Condizione chiara",
        turnover: "Fatturato"
      },
      paydividende: {
        money_holding: "La condivisione del denaro è stata restituita e accumulata (ETH):",
        money_hold: "Paga dividendi per restituire (ETH):",
        paydividends: "Pagare i dividendi (ETH)",
        account_date: "Tempo per ricevere il capitale",
        datehodld: "Data di detenzione del denaro",
        start_end: "Inizio-Fine",
        to: "A",
        operatetype: "Tipo di azione",
        search: "Ricerca",
        charge: "Carica",
        pickup: "Raccolta",
        transaccount: "Trasferire",
        exchange: "Scambio",
        otcbuy: "OTC-Acquista",
        otcsell: "Vendita OTC",
        activityaward: "Premio Attività",
        promotionaward: "Premio Promozione",
        dividend: "Dividendo",
        vote: "Votare",
        handrecharge: "Ricarica artificiale",
        match: "Incontro",
        chargetime: "Tempo di ricarica",
        type: "Tipo",
        num: "Quantità",
        status: "Stato",
        finish: "Finito",
        fee: "Tassa",
        symbol: "Simbolo della moneta"
      },
      record: {
        Please: "Seleziona l'intervallo di date di ricerca",
        start_end: "Inizio-Fine",
        to: "A",
        operatetype: "Tipo di azione",
        search: "Ricerca",
        charge: "Carica",
        pickup: "Raccolta",
        transaccount: "Trasferire",
        exchange: "Scambio",
        otcbuy: "OTC-Acquista",
        otcsell: "Vendita OTC",
        activityaward: "Premio Attività",
        promotionaward: "Premio Promozione",
        dividend: "Dividendo",
        vote: "Votare",
        handrecharge: "Ricarica artificiale",
        match: "Incontro",
        chargetime: "Tempo di ricarica",
        type: "Tipo",
        num: "Quantità",
        status: "Stato",
        finish: "Finito",
        fee: "Tassa",
        shouldfee: "Commissione da pagare",
        revenue: "Tipo di entrate e spese",
        re1: "Eingang",
        re2: "Ausgang",
        discountfee: "Tassa di detrazione",
        realfee: "Servizio",
        symbol: "Simbolo della moneta",
        activitybuy: "Attività Acquista",
        ctcbuy: "ACQUISTO C2C",
        ctcsell: "VENDITA C2C",
        redout: "ROSSO",
        redin: "ROSSO-IN",
        quickExchange: "Scambio rapido",
        currentRate: "Tasso di cambio attuale",
        from: "Da",
        inputexchangeamount: "Inserisci l'importo dello scambio rapido",
        inputexchangepasswd: "Inserisci la password di scambio",
        chooseTransCoinUnit: "Scegli Trans Coin",
        inputTransAmount: "Scegli Importo trasferimento",
        predictAmount: "Scambio",
        qamount: "Importo",
        qrate: "Valutare",
        qexamount: "Importo di scambio",
        withdrawcodein: "Ricarica Codice di Prelievo",
        withdrawcodeout: "PrelievoCodice Prelievo",
        contractfee: "Commissione di scambio",
        contractprofit: "Scambia profitto",
        contractloss: "Perdita di scambio",
        optionfail: "Opzione fallita",
        optionfee: "Commissione di opzione",
        optionreward: "Premio Opzione",
        other: "Altro"
      },
      recharge: {
        recharge: "Depositare",
        symbol: "Coniare",
        address: "Indirizzo di deposito",
        copy: "Copia",
        qrcode: "Codice QR",
        qrcodeaddress: "QRCode per il deposito",
        msg1: "Non ricaricare alcun attivo non in valuta all'indirizzo sopra indicato, altrimenti gli attivi non verranno recuperati.",
        msg2: "Dopo aver effettuato la ricarica all'indirizzo sopra indicato è necessario confermare l'intero nodo di rete, dopo arrivano 2 conferme di rete, dopo 6 è possibile estrarre la conferma di rete.",
        msg3: "Importo minimo di ricarica:",
        msgtop: "Questo indirizzo è solo per la ricarica",
        msg3_1: ", le ricariche inferiori all'importo minimo non verranno contabilizzate.",
        msg4: "Il tuo indirizzo di ricarica non cambierà frequentemente e potrai ripetere la ricarica; in caso di modifiche, cercheremo di avvisarti tramite annuncio sul sito web o e-mail.",
        msg5: "Assicurati di confermare la sicurezza del tuo computer e browser per evitare che le informazioni vengano manomesse o divulgate.",
        record: "Registrazione",
        copysuccess: "Successo!",
        copyerr: "Errore! Copiarlo manualmente",
        time: "Orario di arrivo",
        amount: "Quantità",
        gettingaddress: "Ottenimento dell'indirizzo di deposito, attendere prego...",
        getaddress: "Ottieni l'indirizzo di deposito",
        memotips: "Inserisci questo promemoria durante la ricarica, altrimenti perderai il tuo patrimonio.",
        withdrawrecharge: "Ricarica tramite codice",
        coderechargetip: "Inserisci il codice di prelievo",
        rechargesuccess: "Congratulazioni, ricarica riuscita!",
        rechargeconfirm: "Conferma ricarica",
        status: "Stato"
      },
      withdraw: {
        pickup: "Raccolta",
        addressmanager: "Gestione indirizzi",
        withdrawbycode: "Ritira tramite codice",
        withdrawcode: "Ritira il codice",
        symbol: "Coniare",
        address: "Indirizzo",
        num: "Quantità",
        avabalance: "Saldo disponibile",
        msg1: "La quantità di monete è inferiore a",
        msg2: "Arriva automaticamente all'account, altrimenti è necessaria una revisione manuale",
        increase: "Aumentare il credito",
        tip1: "Inserisci fino a",
        tip11: "cifre decimali e il valore minimo è",
        tip2: "Il valore massimo è",
        numtip1: "Inserisci il numero di monete",
        fee: "Commissioni",
        range: "Allineare",
        arriamount: "Il numero di arrivi",
        msg3: "Il numero minimo di monete è",
        msg4: "valuta",
        msg5: "Al fine di garantire la sicurezza dei fondi, quando la politica di sicurezza del tuo account cambia, le password vengono modificate e utilizzi il nuovo indirizzo per prelevare monete, condurremo un controllo manuale delle monete. Si prega di pazientare e attendere che lo staff chiami o invii un'e-mail.",
        msg6: "Assicurati di confermare la sicurezza del tuo computer e browser per evitare che le informazioni vengano manomesse o divulgate.",
        record: "Registro dei prelievi",
        symboltip: "Seleziona una valuta",
        addresstip: "Si prega di inserire l'indirizzo",
        numtip2: "Inserisci il numero corretto di monete, il valore minimo è",
        numtip3: "L'importo della moneta non deve essere inferiore alla commissione di elaborazione",
        amounttip: "Inserisci l'importo",
        feetip1: "La tariffa minima è",
        feetip2: "Il valore massimo è",
        time: "Tempo di ritiro",
        status: "Stato",
        status_1: "Revisione",
        status_2: "Trasferimento",
        status_3: "Fallimento",
        status_4: "Successo",
        St5: "Parità forte stimata",
        St6: "Attività totali=saldo del portafoglio+non realizzato",
        St7: "Profitti e perdite non realizzati=Profitti e perdite non realizzati calcolati utilizzando l'ultimo prezzo per tutti i contratti di partecipazione",
        St8: "Saldo del portafoglio = trasferimento in entrata - trasferimento in uscita - guadagni e perdite realizzati",
        St9: "Respinto",
        remark: "Osservazione",
        add: "Aggiungere",
        addresslist: "Elenco indirizzi",
        safevalidate: "Verifica della sicurezza",
        telno: "tel",
        mtelno: "Autenticazione del telefono cellulare",
        memail: "Autenticazione della casella di posta",
        smscode: "Codice di verifica del telefono",
        second: "secondo",
        clickget: "Ottenere",
        email: "E-mail",
        emailcode: "Codice di verifica e-mail",
        save: "Salva",
        delete: "Eliminare",
        telerr: "Numero di telefono errato",
        emailerr: "E-mail errata",
        codeerr: "Codice di verifica errato",
        remarktip: "Inserisci l'osservazione",
        savemsg1: "Impossibile salvare!",
        savemsg2: "Salvato con successo!",
        operate: "Operare",
        fundpwdtip: "Inserisci la password dei fondi",
        click: "clic",
        filtrate: "può filtrare",
        txid: "TxId",
        generateCode: "Genera codice di prelievo",
        withdrawcodelist: "Elenco codici di prelievo",
        withdrawcodestatus: "Stato",
        submit: "Invia",
        generatecodesuccess: "PrelievoCodice generato!",
        wi1: "Rete",
        wi2: "Autenticazione di sicurezza",
        wi3: "Importo ricevuto",
        wi4: "Indirizzo di ricezione",
        wi5: "Rete di prelievo",
        wi6: "Importo totale del prelievo",
        wi7: "Commissione di rete",
        wi8: "Assicurati di aver inserito l'indirizzo di prelievo corretto e che la rete di prelievo selezionata corrisponda all'indirizzo",
        wi9: "Gli ordini di prelievo non possono essere annullati dopo la creazione",
        wi10: "Continuare",
        wi11: "Password dei fondi",
        wi12: "codice di verifica mobile",
        wi13: "Inviare",
        wi14: "Codice",
        wi15: "Inviare",
        wi16: "Invia"
      }
    },
    member: {
      usercenter: "Profilo utente",
      securitycenter: "Centro sicurezza",
      securitysetting: "Impostazione di sicurezza",
      accountsetting: "Impostazione dell'account",
      account: "Account",
      assets: "Finanza",
      exchange: "Scambio",
      curdelegate: "Delegato attuale",
      hisdelegate: "Delegato alla Storia",
      otc: "OTC"
    },
    order: {
      ordercenter: "Centro ordini",
      myorder: "Il mio ordine",
      myad: "Il mio annuncio"
    },
    regist: {
      Res1: "Il nome utente è composto da lettere maiuscole e minuscole e numeri e deve contenere lettere",
      hasaccount: "Avere un account？Per accedere",
      login: "Login",
      username: "Nome utente",
      country: "Paese",
      smscode: "Codice di verifica tramite SMS",
      sendcode: "Inviare",
      resendcode: "Invia di nuovo (",
      pwd: "Password",
      repwd: "Conferma password",
      confrimpwd: "Conferma password",
      agreement: "Ho letto e sono d'accordo",
      userprotocol: "Contratto d'uso",
      regist: "Iscrizione",
      teltip: "Inserisci tel",
      telerr: "Errore nel formato del telefono, inseriscilo nuovamente",
      emailtip: "Inserisci l'e-mail",
      emailerr: "Errore nel formato dell'e-mail, inseriscilo nuovamente",
      confirmpwdtip: "Inserisci la password di conferma",
      confirmpwderr: "Due password non uguali!",
      telregist: "Registro telefonico",
      emailregist: "Registrazione e-mail",
      usernametip: "Inserisci il nome utente",
      usernamemsg: "Lunghezza del nome utente non inferiore a 3, non superiore a 15",
      countrytip: "Seleziona il paese",
      smscodetip: "Inserisci il codice di verifica via SMS",
      pwdtip: "Inserisci la password di accesso",
      pwdmsg: "Lunghezza della password non inferiore a 6",
      telno: "tel",
      email: "E-mail",
      agreementtip: "Fare clic per accettare",
      modaltitle: "Per favore verifica",
      promotion: "Codice invito",
      china: "Cina",
      singapore: "Singapore",
      korea: "Corea",
      japan: "Giappone",
      thailand: "tailandia",
      russia: "Russia",
      uk: "Regno Unito",
      vietnam: "Vietnam",
      india: "India",
      italy: "Italia",
      hk: "hk",
      malaysia: "Malaysia",
      taiwan: "Taiwan",
      turkey: "tacchino",
      germany: "Germania",
      france: "Francia",
      spain: "Spagna",
      us: "americano"
    },
    safe: {
      beneficiaryTitle: "Informazioni sul beneficiario",
      beneficiaryEmpty: "Nessun set di informazioni sul beneficiario",
      beneficiaryName: "Nome del beneficiario",
      beneficiaryIdNumber: "Numero ID del beneficiario",
      beneficiaryMobilePhone: "Telefono cellulare del beneficiario",
      beneficiaryNamePlaceholder: "Inserisci il nome del beneficiario",
      beneficiaryIdPlaceholder: "Inserisci il numero ID del beneficiario",
      beneficiaryMobilePlaceholder: "Inserisci il cellulare del beneficiario",
      beneficiaryTip: "Utilizzato per registrare e aggiornare il nome del beneficiario, il numero ID e il telefono cellulare.",
      beneficiaryNameRequired: "Inserisci il nome del beneficiario",
      beneficiaryNameInvalid: "Il nome del beneficiario deve contenere da 2 a 30 caratteri",
      beneficiaryIdRequired: "Inserisci il numero ID del beneficiario",
      beneficiaryIdInvalid: "Il formato del numero ID del beneficiario non è valido",
      beneficiaryMobileRequired: "Inserisci il cellulare del beneficiario",
      beneficiaryMobileInvalid: "Il formato del telefono cellulare del beneficiario non è valido",
      Ad1: "Carica la tua tessera di previdenza sociale, la patente di guida o il passaporto",
      Ad2: "Carica uno dei file prima dell'invio",
      Ad3: "Nome e cognome",
      Ad4: "Indirizzo di contatto",
      Ad5: "Diretta streaming",
      Ad6: "La mia diretta",
      Ad7: "Aggiunta non riuscita, è possibile aggiungerne al massimo 3",
      size: "La dimensione dell'immagine caricata non può superare i 5 MB",
      safelevel_low: "Livello di sicurezza: basso",
      safelevel_high: "Livello di sicurezza: alto",
      safelevel_medium: "Livello di sicurezza: medio",
      nickname: "Soprannome",
      bind: "Legamento",
      binded: "Legato",
      verifypass: "Verificato",
      binding: "Legare",
      binderr: "Fallimento",
      bindretry: "Riprova",
      verified: "Verificato",
      notverified: "Non verificato",
      verifiedtip: "Per proteggere la sicurezza del tuo account, completa la certificazione del nome reale prima di poter effettuare operazioni commerciali!",
      realname: "Nome effettivo",
      idcard: "Carta d'identità",
      upload: "Caricamento",
      upload_positive: "Carica il documento d'identità con foto frontale",
      upload_negative: "Carica la foto sul retro della carta d'identità",
      upload_hand: "Carica foto identificative del palmare",
      save: "Salva",
      reset: "Reset",
      email: "E-mail",
      bindemail: "Associa l'e-mail",
      loginpwd: "Password di accesso",
      emailcode: "Codice di verifica e-mail",
      clickget: "Fare clic per ottenere",
      second: "S",
      phone: "Telefono",
      bindphone: "Associare il telefono",
      phonecode: "Codice di verifica telefonica",
      logintip: "Utilizzare quando si accede alla piattaforma",
      edit: "Modificare",
      oldpwd: "Vecchia password di accesso",
      newpwd: "Nuova password di accesso",
      confirmnewpwd: "Conferma la nuova password",
      fundpwd: "Password del fondo",
      fundtip: "Quando i fondi dell'account cambiano, devi prima verificare la password dei fondi",
      set: "Impostato",
      confirmpwd: "Conferma password",
      oldfundpwd: "Vecchia password del Fondo",
      newfundpwd: "Nuova password del Fondo",
      newpwdmsg1: "Inserisci non meno di 6 nuove password di accesso",
      newpwdmsg2: "La nuova password di accesso non è coerente",
      pwdmsg1: "Inserisci non meno di 6 password",
      pwdmsg2: "Password incoerente",
      emailtip: "Inserisci l'e-mail",
      codetip: "Inserisci il codice di verifica",
      telnotip: "Inserisci il numero di telefono",
      oldpwdtip: "Inserisci la password originale",
      realnametip: "Per favore inserisci il tuo vero nome",
      idcardtip: "Inserisci il numero ID",
      bindphonetip: "Per favore, prima collega il tuo telefono!",
      resetfundpwd: "Reimposta la password dei fondi",
      upload_positivetip: "Si prega di caricare la parte anteriore della carta d'identità con foto",
      upload_negativetip: "Si prega di caricare il retro della carta d'identità con foto",
      upload_handtip: "Carica le foto del documento d'identità del palmare",
      save_success: "Successo!",
      save_failure: "Fallimento!",
      imgtip: "Carica il tuo QRCode per ricevere i contanti del destinatario",
      idcard_verifymsg1: "1. Il file è inferiore a 8 M. Le informazioni sul documento devono essere chiaramente visibili, non è consentita alcuna modifica al documento o alla copertina da parte di oggetti estranei e il numero e il nome del documento devono essere visibili.",
      idcard_verifymsg2: "2. La fotografia dovrebbe mostrarti senza cappello. Si consiglia di non truccarsi. I tratti del viso dei portadocumenti portatili dovrebbero essere chiari e le braccia dovrebbero essere completamente esposte.",
      idcard_verifymsg3: "3. Necessità di tenere sia i documenti tenuti in mano che la copia scritta a mano (nome + data della domanda), \"Tutte le mie azioni su questo sito sono operazioni mie e comprendo i rischi coinvolti e sono disposto a sopportare tutte le conseguenze legali di questo account\"."
    },
    account: {
      pagetitle: "Associa l'account con nome reale",
      pagetip: "Imposta il metodo di pagamento e assicurati di utilizzare il mio account con il nome reale",
      backcardno: "Conto bancario",
      backcardtip: "I dati personali della carta bancaria non sono vincolati",
      modify: "Modificare",
      bind: "Legamento",
      name: "Nome",
      bankaccount: "Conto bancario",
      bankbranch: "Filiale bancaria",
      bankno: "Numero della banca",
      confirmbankno: "Conferma il numero della carta",
      fundpwd: "Password del fondo",
      save: "Salva",
      zfbaccount: "Conto Alipay",
      zfbaccounttip: "Il conto Alipay personale non è vincolato",
      wxaccount: "Conto Wechat",
      wxaccounttip: "L'account personale Wechat non è vincolato",
      banknomsg1: "Inserisci il numero corretto della carta bancaria",
      banknomsg2: "Il numero della carta bancaria inserito due volte non è coerente!",
      verifiedmsg: "Eseguire prima l'autenticazione del nome reale",
      bankaccountmsg: "Seleziona la tua banca",
      bankbranchmsg: "Inserisci il ramo del conto",
      banknomsg: "Inserisci il numero corretto della carta bancaria",
      fundpwdmsg1: "Inserisci la password del fondo corretta",
      fundpwdmsg2: "La password non può contenere meno di 6 caratteri",
      zfbaccountmsg: "Inserisci il conto Alipay",
      wxaccountmsg: "Inserisci l'account WeChat",
      save_success: "Successo!",
      save_failure: "Fallimento!"
    },
    otcorder: {
      unpaid: "Non pagato",
      paided: "Pagato",
      finished: "Finito",
      canceled: "Annullato",
      appealing: "Attraente",
      searchtip: "Inserisci il numero dell'ordine",
      orderno: "N. ordine",
      created: "Tempo",
      symbol: "Coniare",
      type: "Tipo",
      type_sell: "vendere",
      type_buy: "acquistare",
      tradename: "Nome commerciale",
      amount: "Quantità",
      money: "Soldi",
      fee: "Tassa"
    },
    identity: {
      certified: "già certificato",
      placeholder: "Si prega di inserire il motivo della cancellazione",
      apply: "Candidati per diventare un'impresa",
      become: "Diventa BIPPAX Certified Business e goditi più privilegi di transazione",
      zhusnhu: "Le aziende godono di stand pubblicitari esclusivi per aumentare il successo delle transazioni",
      tijiaoziliao: "Invia le informazioni di autenticazione del commerciante",
      place: "Si prega di caricare sulla piattaforma le informazioni di autenticazione del commerciante preparate e di inviarle",
      tijiao: "La verifica della tua certificazione commerciante è stata inviata",
      tijiaosuc: "congratulazioni La tua certificazione commerciante è stata superata",
      tijiaofail: "Mi dispiace! La certificazione del tuo commerciante non è stata superata",
      zhuxiaotijiao: "La tua richiesta di cancellazione dell'attività è stata inviata",
      shenhefail: "La tua richiesta di cancellazione dell'attività non è stata approvata",
      shenhesuc: "La tua richiesta di cancellazione dell'attività è stata approvata",
      shangjiazhuxiao: "cancellazione dell'attività",
      shenagain: "revisione",
      shenheshibai: "Controllo fallito",
      sheqinggain: "Per candidarsi",
      reason: "motivo",
      shenqingtuibao: "Richiedi un prestito",
      getquan: "Hai le seguenti autorizzazioni",
      read: "Ho letto e sono d'accordo",
      lijishenqing: "Applicare immediatamente",
      tips: "richiesta",
      wufachexiao: "Ti trovi nell'operazione di cancellazione dell'attività, dopo aver confermato l'invio dell'operazione di richiesta, non potrà essere revocata.",
      suredo: "Sei sicuro che sia stato fatto?",
      shuzizichan: "Certificato di scambio di risorse digitali",
      gerenzichan: "Certificato di risorsa digitale personale",
      second: {
        line: "Come fare domanda per affari?",
        step1: "Passaggio 1: preparare i materiali per la domanda aziendale come richiesto",
        step1c1: "Preparare la seguente applicazione:",
        step1c2: "Numero di cellulare, ID WeChat, numero QQ, certificato di risorsa digitale personale (immagine), certificato di transazione di risorsa digitale (immagine)",
        step2: "Passaggio 2: inviare la domanda",
        step2c: "Per completare i materiali dell'audit di certificazione aziendale che devono essere compilati e caricati, fare clic su Invia per l'approvazione.",
        step3: "Fase 3: verifica dei dati",
        stepc: "Esamineremo le tue richieste aziendali per i prossimi tre-cinque giorni, tieni gli occhi aperti, ma puoi inviare una pagina. Dopo l'approvazione potrete pubblicare l'annuncio nell'area cambio francese.",
        agree: "Ho accettato di congelare",
        agreec: "Come deposito commerciale",
        shenqingchngweishangjia: "Candidati per affari"
      },
      yuanyin: "motivo",
      bizhong: "Valuta di deposito",
      shuliang: "Importo del margine",
      chosen: "Seleziona la valuta",
      seat: "Stand esclusivo",
      service: "Servizio individuale",
      lowfee: "Commissioni più basse",
      phone: "Telefono",
      balance: "Beni personali",
      cardphoto: "Foto identificative positive e negative",
      wx: "Wechat",
      exchange: "Se impegnarsi nella negoziazione fuori borsa di risorse digitali",
      handphoto: "Utente in possesso di foto identificativa",
      qq: "QQ",
      ploy: "Se esiste una corrispondente strategia di controllo del rischio",
      agreement: "《Contratto commerciale certificato》",
      applyfor: "Fare domanda a",
      sendcode: "Inviare",
      confirm: "Confermare",
      prepare: "Preparare i materiali",
      result: "Aspetta il risultato",
      review: "Invia recensione",
      passed: "Revisione superata",
      approve: "Accetta il contratto commerciale di certificazione",
      emailtip1: "Si prega di inviare via email i seguenti materiali a",
      emailtip2: "Esamineremo la tua richiesta il prima possibile."
    },
    extension: {
      title1: "Collegamenti di promozione",
      title2: "Amici della promozione",
      title3: "La mia commissione",
      linkdesc: "Il seguente URL è il tuo indirizzo per la promozione nel mondo esterno. Puoi promuoverlo tramite amici, QQ, Wechat, Weibo, blog, forum o il tuo sito web. Tutte le persone che hanno effettuato l'accesso tramite questo indirizzo saranno tuoi utenti dopo la registrazione. E quando questi utenti inviano strategie in questo sito, puoi guadagnare commissioni e la promozione dettagliata può essere visualizzata nel record di accesso.",
      linktitle: "I tuoi link romozionali",
      copy: "Copia",
      copy_msg1: "Copia con successo!",
      copy_msg2: "Errore! Copiarlo manualmente",
      username: "Nome",
      currrecharge: "Transazione",
      userlevel: "Livello utente",
      createdtime: "Orario di registrazione",
      currcommission: "Commissione attuale",
      managerfee: "commissione di gestione",
      yuan: "yuan(RMB)",
      symbol: "CONIARE",
      amount: "Quantità",
      remark: "Osservazione",
      amounttime: "Consegnare il tempo"
    },
    promotion: {
      title: "Centro Promozione",
      subtitle1: "Le mie carte",
      subtitle2: "Scambiare record",
      subtitle3: "La mia promozione",
      card_column0: "Codice di scambio",
      card_column1: "Nome",
      card_column2: "Simbolo della moneta",
      card_column3: "Quantità",
      card_column4: "Scadenza",
      card_column5: "Totale",
      card_column6: "Scambiato",
      card_column7: "Crea tempo",
      my_column0: "Invita utente",
      my_column1: "Data di registrazione",
      my_column2: "Vero nome",
      gopromotion: "Promozione",
      inputcardno: "Inserisci il codice della carta",
      exchange: "Scambio",
      exchangesuccess: "Congratulazioni! Puoi controllare la risorsa nel centro finanziario!",
      exchangewithcode: "Scambio con codice"
    },
    activity: {
      navTitle: "Innovazione",
      subNavTitle1: "I miei ordini",
      subNavTitle2: "Le mie miniere",
      subNavTitle3: "Il mio bloccato",
      column1: "Nome",
      column2: "Tipo",
      column3: "Quantità",
      column4: "Unità (DENTRO)",
      column5: "Unità (FUORI)",
      column6: "Stato",
      column7: "Fatturato",
      column8: "Crea tempo",
      mColumn1: "Immagine",
      mColumn2: "Nome",
      mColumn3: "Unità moneta",
      mColumn4: "Periodo",
      mColumn5: "Giornate minerarie",
      mColumn6: "MiningDays",
      mColumn7: "Stato",
      mColumn8: "Capacità di base",
      mColumn9: "Capacità attuale",
      mColumn10: "Estrazione totale",
      mColumn11: "Data di fine",
      mColumn12: "Crea data",
      lColumn1: "Immagine",
      lColumn2: "Nome",
      lColumn3: "Unità moneta",
      lColumn4: "Periodo",
      lColumn5: "Giorni chiusi",
      lColumn6: "Giorni di rilascio",
      lColumn7: "Stato",
      lColumn8: "Capacità di base",
      lColumn9: "Capacità attuale",
      lColumn10: "Totale rilasciato",
      lColumn11: "Data di fine",
      lColumn12: "Crea data"
    },
    mining: {
      title: "La mia lista mineraria",
      empty: "Nessun record",
      day: "Giorno",
      week: "Settimana",
      month: "Mese",
      year: "Anno",
      invitetip1: "La capacità della macchina mineraria può essere migliorata invitando gli amici. Ogni persona invitata a scambiare la macchina da miniera ne aumenterà la capacità",
      invitetip2: "Limite superiore di aumento della capacità",
      miningUnit: "Unità mineraria",
      miningPeriod: "Periodo minerario",
      miningDays: "Tempi minerari",
      miningedDays: "Tempi minati",
      miningDaysProfit: "Uscita di base",
      miningCurrentDaysProfit: "Uscita corrente",
      status0: "Da schierare",
      status1: "Distribuito",
      status2: "Sopra"
    },
    locked: {
      title: "La mia lista bloccata",
      empty: "Nessun record",
      day: "Giorno",
      week: "Settimana",
      month: "Mese",
      year: "Anno",
      invitetip1: "La capacità della stanza chiusa può essere migliorata invitando gli amici. Ogni persona invitata a scambiare la serratura aumenterà la capacità",
      invitetip2: "Limite superiore di aumento della capacità",
      miningUnit: "Unità di rilascio",
      miningPeriod: "Periodo di rilascio",
      miningDays: "Tempi di rilascio",
      miningedDays: "Tempi di rilascio",
      miningDaysProfit: "Uscita di base",
      miningCurrentDaysProfit: "Uscita corrente",
      status0: "Essere rilasciato",
      status1: "Rilasciando",
      status2: "Sopra",
      totallocked: "Totale bloccato"
    },
    api: {
      apiAdmin: "Gestione dell'API",
      createApi: "Crea una nuova chiave API",
      mark: "osservazione",
      bindAddress: "La chiave dell'indirizzo IP non associata è valida per 90 giorni",
      hint: "suggerimento",
      part1: "Ti forniamo una potente API, puoi utilizzare query di mercato, transazioni automatiche e altri servizi",
      apiDoc: "dalla documentazione API.",
      howUse: "Scopri come utilizzare",
      part2: "Crea fino a 5 set di chiavi API per utente",
      part3: "Ti preghiamo di non rivelare la tua chiave API per evitare la perdita di risorse. Per motivi di sicurezza, si consiglia di associare l'IP alla chiave API, con un massimo di 5 IP per ciascuna chiave API. Compila direttamente un singolo indirizzo, più indirizzi IP con mezze virgole angolari, ad esempio 192.168.1.1, 192.168.1.2 invece, 192.168.1.3.",
      myApiKey: "La mia chiave API",
      ipAddress: "Indirizzo IP",
      createTime: "CreaOra",
      accessKey: "Chiave di accesso",
      bindIpAddress: "Associa l'indirizzo IP",
      ioDays: "I giorni rimanenti",
      operation: "operazione",
      create: "creare",
      edit: "modificare",
      delete: "eliminare",
      sureDelete: "Sei sicuro di voler eliminare?",
      tips: "La chiave viene visualizzata solo quando viene aggiunta, salvala in tempo.",
      copy: "copia",
      access: "chiave",
      okText: "Sicuro",
      cancel: "cancellare"
    }
  },
  cms: {
    noticecenter: "Centro annunci",
    newshelp: "Nuovo utente in aiuto",
    appdownload: "Scarica l'app",
    onlineservice: "servizio in linea",
    faq: "Domande frequenti",
    notice: "Annuncio",
    servicecenter: "Centro clienti",
    about: "Di",
    joinus: "Unisciti a noi",
    aboutus: "Chi siamo",
    exchangerule: "Regole di negoziazione",
    useprotocol: "Contratto di utilizzo",
    feenote: "Descrizione della tariffa",
    merchantprocotol: "Contratto commerciale",
    features: "Caratteristiche",
    contactus: "Contattaci",
    noticelist: "Tutti gli annunci",
    nextnotice: "PROSSIMO",
    prevnotice: "PREC",
    notexist: "La pagina che hai visitato non esiste o è stata cancellata",
    otherhelp: "Altro in questa categoria",
    scanforshare: "Scansiona per condividere",
    download: "Scaricamento",
    downloadslogan: "APP BIPPAX - Fai trading ovunque."
  },
  description: {
    title1: "Sicurezza",
    title2: "Servizio 24 ore su 24",
    title3: "Scambio globale",
    title4: "Rigorosamente progetto",
    message1: "Sistema di controllo del vento finanziario completo e sistema antifurto, portafoglio caldo e freddo, sistema multi-firma per garantire la sicurezza dei fondi",
    message2: "L'audit online manuale 24 ore su 24 può proteggere i clienti dalla perdita delle migliori opportunità di investimento.",
    message3: "La copertura della rete di servizi aziendali globali ti aiuta a investire in risorse crittografate globali e a effettuare transazioni con utenti globali",
    message4: "Selezioniamo rigorosamente i progetti blockchain di alta qualità per filtrare per te l'80% dei progetti ad alto rischio.",
    scanqrcode: "Scarica l'APP",
    aboutdesc1: "BIPPAX.PRO è una piattaforma di trading di asset digitali leader nel mondo, registrata nelle Isole Cayman, con un team operativo principale a Hong Kong. I membri principali di BIPPAX.PRO provengono dalle migliori società Internet e finanziarie. La maggior parte di loro crede profondamente nel Bitcoin e nelle catene di blocchi. Siamo convinti che le catene di blocchi cambieranno il tradizionale sistema finanziario monopolistico e costruiranno una struttura sociale più democratica e autonoma.",
    aboutdesc2: "La piattaforma BIPPAX.PRO ha un'architettura di trading professionale a livello finanziario, un motore di trading di corrispondenza ad alta memoria simultanea autosviluppato. La piattaforma utilizza un sistema di portafoglio completamente ricaricabile + firme multiple + sistema di attacco DDOS ad alta protezione e altre architetture di trading per garantire la sicurezza delle risorse del cliente.",
    aboutdesc3: "Per consentire ai clienti di cogliere meglio le opportunità di investimento, BIPPAX.PRO adotta una gestione piatta nel servizio clienti e stabilisce un meccanismo di risposta al servizio estremamente rapido. Il responsabile del servizio clienti asset è online 7 ore su 7, 24 ore su 24, tutto l'anno, fornendo ai clienti servizi di ricarica e incasso degli asset e garantendo che i clienti completino la ricarica in 25 minuti.",
    aboutdesc4: "BIPPAX.PRO controlla rigorosamente progetti di alta qualità e fornisce servizi di hosting di risorse sicuri e stabili. BIPPAX.PRO sostiene il concetto di \"onestà, giustizia, entusiasmo e apertura\" e si impegna a creare uno scambio finale sicuro, affidabile, efficiente e amichevole per gli utenti.",
    aboutdesc5: "Sebbene le risorse digitali al momento siano solo una piccola cerchia, crediamo che questo tipo di risorse che tutti possono comprendere appieno sarà popolare in futuro. Lavoriamo insieme e non vediamo l'ora!",
    support: "Supporto",
    report: "Suggerimento",
    service: "Assistenza clienti",
    apply: "Consiglio di amministrazione",
    coop: "Cooperazione",
    community: "Comunità BIPPAX",
    wechat: "Wechat",
    addwechat: "Aggiungi \"coinex\" come amici Wechat e poi entra nella comunità Wechat",
    weibo: "Weibo",
    twitter: "Twitter",
    biyong: "Biyong",
    telegram: "Telegramma",
    medium: "Medio",
    reddit: "Reddit"
  },
  bzb_description: {
    title1: "",
    title2: "",
    title3: "",
    title4: "",
    title5: "",
    title6: "",
    title7: "",
    title8: "",
    desc1: "",
    desc2: "",
    desc3: "",
    desc4: "",
    desc5: "",
    desc6: "",
    desc7: "",
    desc8: ""
  },
  footer: {
    wechatkefu: "servizio wechat",
    notice: "Annuncio",
    gsmc: "Scambia la migliore criptovaluta",
    bah: "N. 13026899 -3, Shanghai ICP",
    gsjj: "Profilo",
    gywm: "Chi siamo",
    jrwm: "Unisciti a noi",
    biyong: "BiYong",
    lxwm: "Contattaci",
    yqlj: "Collegamenti",
    bzzx: "Aiuto",
    xsrm: "Un corso per principianti",
    czzn: "Guida alla ricarica",
    jyzn: "Guida allo scambio",
    ptsm: "Spiegare",
    fysm: "Commissioni",
    fwtk: "Politica di servizio",
    fltk: "Politica legale",
    wechat: "Servizio clienti Wechat",
    xszn: "Guida per principianti",
    cjwt: "Domande frequenti",
    mztk: "Disclaimer",
    ystk: "politica sulla riservatezza",
    tkxy: "Condizioni",
    gybzb: "A proposito di BZB",
    kfyx: "E-mail di servizio",
    swhz: "Cooperazione",
    sbsq: "Applicazione di mercato",
    bzzl: "Informazioni sulla moneta",
    tsjb: "Rapporto",
    apidoc: "ApiDoc",
    zwkf: "vieni presto"
  },
  index: {
    circulation: "Circolazione dei fondi per la sicurezza e lo sviluppo",
    hourEth: "Entrate cumulative da distribuire oggi",
    yesterdayEth: "Entrate cumulative da distribuire ieri",
    yesterday: "Produzione mineraria del giorno precedente:",
    bhbTotal: "BHB Flusso totale",
    bhbSecond: "BHB Circolazione del mercato a due livelli",
    checkMineprinciple: "Visualizza il principio del mining",
    checkFlowVolum: "Ispezione della circolazione",
    checkLockPosition: "Controlla la situazione della serratura",
    BHBregister: "Registrazione dell'account BIPPAX",
    tibi: "Il tempo e il limite del pagamento del denaro sulla fattura",
    line_plane: "Annuncio sul piano on-line di BHB, sulla restituzione della tassa di circolazione e di servizio",
    fenpeijizhi: "Una descrizione del meccanismo di distribuzione del reddito BIPPAX",
    jiangli_jihua: "Invito al sistema di premi minerari",
    friend_fanhuan: "Invita amici, guadagna una commissione extra e ritorna"
  },
  plate: {
    title: "Schema di distribuzione del reddito della piattaforma (patrimonio netto del titolare BHB)",
    content1: "Come descritto nel white paper, BIPPAX occuperà l'80% della piattaforma (al netto di tasse e commissioni). Il reddito viene assegnato ai titolari di BHB e il 20% delle entrate viene utilizzato per supportare la ricerca e lo sviluppo e il funzionamento della piattaforma.",
    content2: "La distribuzione del reddito richiede giorni come ciclo di distribuzione e il 6 giugno 2018 come primo giorno di distribuzione. Ogni giorno successivo, il reddito totale da distribuire il giorno precedente verrà assegnato in proporzione ai titolari di BHB.",
    content3: "（avviso: 1. il BHB qui si riferisce solo al BHB che è stato rilasciato/distribuito. Vedi anche【",
    content3_1: "Nota sul rapporto tra circolazione BHB / partecipazione alla distribuzione del reddito",
    content3_2: "2. l'istantanea oraria (punto intero) viene calcolata una volta e la distribuzione del reddito viene eseguita una volta al giorno.",
    hourFenpei: "Distribuzione del reddito oggi",
    hourTotal: "Reddito totale della piattaforma odierna",
    xiangqing: "Dettagli della distribuzione del reddito odierna",
    yesterdaytit: "Distribuzione del reddito ieri",
    yesterdaytotal: "Entrate totali della piattaforma di ieri",
    yesterdayxiangqing: "Dettagli della distribuzione del reddito di ieri",
    yesterday: {
      total: "Ricavi totali",
      allocated: "Ricavi non distribuiti"
    }
  },
  feereturn: {
    ruletitle: "Nota",
    rulecontent: "Il nostro Libro bianco contiene una spiegazione dettagliata del rimborso delle commissioni di transazione. Nel complesso, il 51% della base BHB totale delle piattaforme (da ora in poi denominata \"porzione di ricompensa della comunità\") verrà rimborsato agli utenti nel tempo tramite il nostro meccanismo \"Trans-Fee Mining\". Tuttavia, una volta che questo 51% del totale dei BHB sarà stato completamente rilasciato tramite rimborso, il meccanismo \"Trans-Fee Mining\" terminerà automaticamente.",
    recordtitle: "Lista",
    recordcontent: "Ogni giorno (UTC+8, come di seguito) BHB rimborserà il 100% delle commissioni di transazione degli utenti sostenute dal giorno precedente sotto forma di BHB. Ciò verrà fatto utilizzando il prezzo medio BHB del giorno precedente (questo prezzo medio viene calcolato come valore totale transato/volume totale transato). Completeremo questo rimborso delle commissioni di transazione del giorno precedente sotto forma di BHB, tutti i giorni alle 11:00.",
    time: "Data",
    todaycharge: "Prezzo medio (ETH)",
    totalChange: "Totale (ETH)",
    returnCharge: "Rimborso Mining Trans-Fee (BHB)",
    todayChargeReturn: "Programma di incentivi per il rimborso di FCoin（BHB）"
  },
  home: {
    login: {
      title: "Inizia a fare trading di criptovalute",
      desc: "Supporta oltre 500 criptovalute e una varietà di strumenti di trading",
      btnText: "Fai trading adesso"
    },
    unlogin: {
      title: "Inizia il tuo viaggio con le risorse digitali",
      desc: "Registrati e goditi il ​​pacchetto regalo per i nuovi utenti",
      placinfo: "Telefono/e-mail",
      btnText: "Registro"
    },
    WelfareCenter: "Centro Benessere",
    Welcome_ceremony: "Regalo per nuovi utenti",
    Airdrop: "Lancio aereo",
    DailyGain: "Premi giornalieri",
    AirdropGift: "Regali di lancio aereo",
    financial_management: "Gestione finanziaria ottimizzata",
    Zhoude: "Premi settimanali",
    height_is: "fino a",
    Happiness: "Carnevale della Fortuna",
    Monthly: "Premi mensili",
    CarveUp: "Montepremi",
    download: {
      transactions_anytime: "Fai trading sempre e ovunque",
      scan_code: "Scansione per scaricare",
      download_more: "Scarica altro"
    },
    brand: {
      digital_platform: "Piattaforma leader per il trading di asset digitali",
      rich_digital: "Ricchi servizi di trading di asset digitali e di gestione patrimoniale per soddisfare le diverse esigenze di trading",
      High_quality_digital: "Risorse digitali di alta qualità",
      Turnover: "Fatturato",
      safety_risk: "Sistema di sicurezza e gestione del rischio di livello mondiale",
      multi_factor: "Archiviazione offline, crittografia a più fattori, monitoraggio della piattaforma 24 ore su 24, 7 giorni su 7, protezione completa della sicurezza delle risorse degli utenti",
      Security_reserve: "Fondo di riserva di sicurezza",
      accident: "0 incidenti in 9 anni",
      safetyrisk: "Sicurezza e controllo dei rischi di massimo livello",
      choice_trusted: "La scelta scelta da milioni di utenti",
      transaction_service: "Creazione di centri di servizi di transazione localizzati in più paesi e regioni in tutto il mondo, creando un ecosistema blockchain con molteplici forme di business",
      ten_thousand: "10.000",
      User_preference: "Preferito dagli utenti",
      Countries_covered: "Paesi coperti"
    },
    trading: {
      digital_currency: "Inizia il tuo viaggio con le risorse digitali",
      register: "Registro",
      login: "Login",
      currency_transaction: "Inizia a fare trading di criptovalute",
      to_trade: "Fai trading adesso"
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/it/index.js